import { Component, OnInit, ViewChild, TemplateRef, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router'
import { Columns, Config, DefaultConfig, APIDefinition, API } from 'ngx-easy-table';
import { IntranetoldService } from './../../../api/intranetold.service';
import { DocumentoMarting, DocumentoMarketingDetalle } from '../../../model/ventaModel'
import { listaArticuloComponent } from "./listaArticulo"
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2'
import { variableGlobal } from 'src/app/global.enum';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { listaClienteComponent } from './listaCliente';
import { listaDireccionComponent } from './listaDireccion';
import { listaLoteComponent } from './listaLote';
import { listaSerieComponent } from './listaSerie';
import { SapService } from './../../../api/sap.service';
import { PagoModalComponent, CobroTbkRescate } from '../pagos/pago-modal.component';
import { TransbankService } from 'src/app/api/transbank.service';
import { VentaService } from 'src/app/api/venta.service';
import { CuentasSocioComponent } from './cuentas-socio/cuentas-socio.component';
import { abreTablaGenericoComponent } from '../../app/query-mongo/abreTablaGenerico';
import { INDESADService } from 'src/app/Business/INDESAD.service';
import { MongoService } from 'src/app/api/mongo.service';
import { DOCUMENTO_MARKETING_PRELIMINAL, MODELO_APROBACION, aprobadores, SolicitarAprobacion } from 'src/app/model/Mongo';
import { ModeloAprobacionCRMComponent } from './ModeloAprobacion/ModeloAprobacion.component';
import { IndesadService } from 'src/app/api/indesad.service';
import { element } from 'protractor';
import { SocioNegocioComponent } from '../socio-negocio/socio-negocio.component';
import { DATE } from '@amcharts/amcharts4/core';
import { environment } from 'src/environments/environment';
import { CrearOportunidadComponent } from '../oportunidad/crear-oportunidad/crear-oportunidad.component';
import { SeguimientoOportunidadComponent } from '../seguimiento/seguimiento-oportunidad/seguimiento-oportunidad.component';
import { ListahistorialdevolucionComponent } from './listahistorialdevolucion/listahistorialdevolucion.component';
import {
  redondear, decimalesPrecioEfectivos, netoDesdeBruto, brutoDesdeNeto, brutoEsConsistente,
  precioTrasDescuento, totalLinea, impuestosDocumento, cuadrarDocumento, LineaCuadratura
} from './venta-cuadratura';


@Component({
  selector: 'app-venta',
  templateUrl: './venta.component.html',
  styleUrls: ['./venta.component.sass']
})
export class VentaComponent implements OnInit {

  constructor(
    private _activeRoute: ActivatedRoute,
    private _api: IntranetoldService,
    private modalService: NgbModal,
    private _dbService: NgxIndexedDBService,
  private _apiSap: SapService,
  private _ventaService: VentaService,
    private _apiIndesad: IndesadService,
    private _apiMongo: MongoService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {

  }
  @ViewChild('table', { static: true }) table: APIDefinition;
  myControl = new FormControl('');
  date = new Date();
  Archivos:any = [];
  data: DocumentoMarting = {

    OCBase64Nombre:"",
    OCBase64Formato:"",
    OCBase64:"",
    UserFields: [
       /*
      {
        Field: "U_IND_COMENTARIO_FACTURA",
        FieldType: "String",
        Value: "",
      }*/
    ],
    Draft: false,
    SubObjType: null,
    DocEntry: -1,
    DocNum: -1,
    Rate: 1,
    CardCode: null,
    CardName: null,
    Currency: "CLP",
    NumAtCard: null,
    Series: -1,
    DocType: "I",
    ShipToCode: null,
    PayToCode: null,
    Address: null,
    Address2: null,
    GroupNum: null,
    GroupCode: null,
    TrnspCode: null,
    U_IND_Tipo_E: null,
    TaxDate: null,
    DocDueDate: null,
    DocDate: null,
    ObjType: null,
    SlpCode: -1,
    OwnerCode: null,
    Comments: "",
    GrossProfit: 0,
    DiscPrcnt: 0,
    DiscTotal: 0,
    TotalExpns: 0,
    VatSum: 0,
    DocTotal: 0,
    DescuentoCampoUsuario: 10,
    Detalles: [],
    BillToDef: null,
    ShipToDef: null,
    ListaDePrecioSocio: null,
    ListaCUrrency: false,
    AtcEntry: -1,
    AddresList: {
      StreetS: null,
      StreetNoS: null,
      BlockS: null,
      CityS: null,
      ZipCodeS: null,
      CountyS: null,
      StateS: null,
      CountryS: null,
      BuildingS: null,
      Address2S: null,
      Address3S: null,
      GlbLocNumS: null,
      StreetB: null,
      StreetNoB: null,
      BlockB: null,
      CityB: null,
      ZipCodeB: null,
      CountyB: null,
      StateB: null,
      CountryB: null,
      BuildingB: null,
      Address2B: null,
      Address3B: null,
      GlbLocNumB: null,

    }
  };
  TaxCode = "ILA";
  TaxRate = 0;
  TaxName: string = "ILA";
  // Split tax sums for display
  private primaryTaxSum: number = 0; // Sum for selected tax (e.g., ILA)
  private extraIvaSum: number = 0;   // Sum for additional IVA shown separately when applicable (e.g., ILA)
  ObjType;
  DocEntry;
  Origen;
  titulo: string;
  creaActualiza: string;
  BodegaEditable: boolean;
  activaAgregarArticulo: boolean = false;
  usuario;
  listaMateriales: any;
  public configuration: Config;
  public columns: Columns[];
  columnsCopy: any[] = [];
  DESPACHO: any;
  FACTURA: any;

  OSTC: any;
  OHEM: any;
  OSLP: any;
  OCRN: any;
  OCTG: any;
  OSHP: any;
  OWHS: any;
  OCRD: any;
  OITMFrgnName: any;
  IMPUESTOS: any;
  OCRDCopy: any;
  IND_Tipo_E: any;
  FILES: any;
  VATLiable: any;
  oportunidades:any;
  oportunidadesView:any;
  oportunidadesFiltrados:any = [];
  oportunidadSeleccionada:any;
  cargando:boolean = false;
  loadingMessage: string = 'Cargando...';
  // Loading específico para carga de códigos (barcodes / artículos) al primer uso
  cargandoCodigos: boolean = false;
  private readonly defaultLoadingMessage: string = 'Cargando...';
  private readonly codeLoadingMessage: string = 'Cargando códigos, por favor espere...';
  //checked:any = [];
  monedaLocal;
  checked = new Set([]);
  @ViewChild('frmItemCode', { static: true }) frmItemCode: TemplateRef<any>;
  @ViewChild('frmFrgnName', { static: true }) frmFrgnName: TemplateRef<any>;
  @ViewChild('frmCodTransworld', { static: true }) frmCodTransworld: TemplateRef<any>;
  @ViewChild('frmDscription', { static: true }) frmDscription: TemplateRef<any>;
  @ViewChild('frmFactor1', { static: true }) frmFactor1: TemplateRef<any>;
  @ViewChild('frmFactor2', { static: true }) frmFactor2: TemplateRef<any>;
  @ViewChild('frmQuantity', { static: true }) frmQuantity: TemplateRef<any>;
  @ViewChild('frmSalUnitMsr', { static: true }) frmSalUnitMsr: TemplateRef<any>;
  @ViewChild('frmBuyUnitMsr', { static: true }) frmBuyUnitMsr: TemplateRef<any>;
  @ViewChild('frmPrice', { static: true }) frmPrice: TemplateRef<any>;
  @ViewChild('frmOnHand', { static: true }) frmOnHand: TemplateRef<any>;
  @ViewChild('frmDisc', { static: true }) frmDisc: TemplateRef<any>;
  @ViewChild('frmPriceAfeterDisc', { static: true }) frmPriceAfeterDisc: TemplateRef<any>;
  @ViewChild('frmLineTotal', { static: true }) frmLineTotal: TemplateRef<any>;
  @ViewChild('frmTaxCode', { static: true }) frmTaxCode: TemplateRef<any>;
  @ViewChild('frmShipDate', { static: true }) frmShipDate: TemplateRef<any>;
  @ViewChild('frmAccion', { static: true }) frmAccion: TemplateRef<any>;
  @ViewChild('frmWhsCode', { static: true }) frmWhsCode: TemplateRef<any>;
  @ViewChild('frmEstadoWMS', { static: true }) frmEstadoWMS: TemplateRef<any>;
  tipoCambio: number = 1;
  // Intento de pago capturado desde el modal para aplicar luego de crear FAC/BOL
  pagoIntent: { cheque?: any[]; transferenciaBancaria?: any; tarjetaCredito?: any[]; efectivo?: any } | null = null;
  cobroRescate: CobroTbkRescate | null = null;

  objetoSAP: any;
  // Bodega por defecto del usuario (si existe). Cuando está definida, se bloquea la edición de bodega y todas las líneas usan esta.
  private defaultWarehouseCode: string | null = null;

  private selectedFile: File;
  // Base de referencia para factura (ObjType 13)
  baseNVEntry: number | null = null; // DocEntry de la Nota de Venta seleccionada
  baseNVDocNum: number | null = null; // DocNum de la Nota de Venta seleccionada

  // --- Barcode scanning & buffer ---
  showScanner = false;
  scannerError: string | null = null;
  private mediaStream: MediaStream | null = null;
  private barcodeDetector: any;
  @ViewChild('scannerVideo') scannerVideoRef!: ElementRef<HTMLVideoElement>;
  @ViewChild('fallbackCapture') fallbackCaptureRef!: ElementRef<HTMLInputElement>;
  scannedBuffer = new Map<string, number>();
  scanManualCode: string = '';
  @ViewChild('manualScanInput') manualScanInputRef!: ElementRef<HTMLInputElement>;

  bufferCount(): number { return Array.from(this.scannedBuffer.values()).reduce((a,b)=>a+b,0); }
  scannedList() { return Array.from(this.scannedBuffer.entries()).map(([code,count])=>({code,count})); }
  clearBuffer() { this.scannedBuffer.clear(); }
  addCodeToBuffer(code: string) {
    const raw = (code || '').trim();
    if (!raw) return;
    let base = raw;
    let qty = 1;
    const pipeIndex = raw.lastIndexOf('|');
    if (pipeIndex > -1) {
      base = raw.substring(0, pipeIndex).trim();
      const qStr = raw.substring(pipeIndex + 1).trim();
      const parsed = Number(qStr);
      if (!isNaN(parsed) && parsed > 0) qty = parsed; // si es válido y >0
    }
    if (!base) return;
    this.scannedBuffer.set(base, (this.scannedBuffer.get(base) || 0) + qty);
  }

  // Cache doble: ItemCode y CodeBars
  private listaMaterialesCache: Map<string, any> | null = null;         // por ItemCode
  private listaMaterialesBarra: Map<string, any> | null = null;         // por CodeBars
  private async ensureListaMaterialesCache(): Promise<Map<string, any>> {
    if (this.listaMaterialesCache && this.listaMaterialesBarra) return this.listaMaterialesCache;
    let query: string = await this.obtieneQueryMongo('ListaMateriales');
    const listNum = this.data.Currency === 'CLP' ? 2 : (this.data.Currency === 'USD' ? 3 : 2);
    query = query.replace('REEMPLAZA', listNum.toString());
    if (this.data.Currency != 'CLP') {
      query = query.replace("T2.[Price]", "T2.[Price], '" + this.data.Currency + "' AS [CurrencyOther], ROUND(T2.[Price] / " + this.tipoCambio + ", " + variableGlobal.DECIMALES_OTRA_MONEDA + ") AS [PriceOther]");
      if (this.data.ObjType=="540000006"|| this.data.ObjType=="22") {
        query = query.replace("T0.[SellItem] = 'Y'","T0.[PrchseItem] = 'Y'");
      }
    }
    const res:any = await this._api.GetNotFileQuery(query);
    const mapa = new Map<string, any>();
    const mapaBarra = new Map<string, any>();
    (res.objeto as any[]).forEach(r=> {
      if (!r) return;
      if (r.ItemCode) mapa.set(String(r.ItemCode), r);
      // Posibles nombres de campo de código de barras
      const posibles = ['CodeBars','BarCode','BarCodes','Barcode'];
      let valor = '';
      for (const k of posibles) {
        if (r[k]) { valor = String(r[k]).trim(); break; }
      }
      if (valor) {
        mapaBarra.set(valor, r);
        // Normalización adicional: si es puramente numérico, agregar versión sin ceros a la izquierda
        if (/^\d+$/.test(valor)) {
          const sinCeros = valor.replace(/^0+/, '');
            if (sinCeros && sinCeros !== valor) mapaBarra.set(sinCeros, r);
        }
      }
    });
    this.listaMaterialesCache = mapa;
    this.listaMaterialesBarra = mapaBarra;
    return mapa;
  }

  // Agrega un código (manual o escaneado) y retorna true si se agregó/actualizó algún producto
  async addManualCodeDirect(code: string): Promise<boolean> {
    const raw = (code||'').trim();
    if (!raw) return false;
    let c = raw;
    let qty = 1;
    const pipeIndex = raw.lastIndexOf('|');
    if (pipeIndex > -1) {
      c = raw.substring(0, pipeIndex).trim();
      const qStr = raw.substring(pipeIndex + 1).trim();
      const parsed = Number(qStr);
      if (!isNaN(parsed) && parsed > 0) qty = parsed; else qty = 1;
    }
    if (!c) return false;

    // Mostrar loader específico si la caché de materiales aún no está lista
    const needCache = !(this.listaMaterialesCache && this.listaMaterialesBarra);
    if (needCache) { this.loadingMessage = this.codeLoadingMessage; this.cargandoCodigos = true; }
    try {
      // Si ya existe línea por ItemCode exacto, suma cantidad
      const idx = this.data.Detalles.findIndex(d=> d.ItemCode === c);
      if (idx >= 0) {
        this.data.Detalles[idx].Quantity = (this.data.Detalles[idx].Quantity||0) + qty;
        this.cambiaDatoLinea(this.data.Detalles[idx], idx, 'CANTIDAD');
        setTimeout(()=>{
          const el = document.getElementById('qty-'+idx) as HTMLInputElement; el?.focus(); el?.select();
        },0);
        return true;
      }
      // Buscar en cache lista materiales
      const cache = await this.ensureListaMaterialesCache();
      // Intentar primero por código de barras
      if (!this.listaMaterialesBarra) await this.ensureListaMaterialesCache();
      let base = this.listaMaterialesBarra?.get(c) || cache.get(c);
      if (!base && /^\d+$/.test(c)) {
        // Intentar con versión con ceros agregando y quitando (heurística mínima)
        const conCeros = c.padStart(13,'0');
        base = this.listaMaterialesBarra?.get(conCeros) || base;
      }
      if (!base && this.listaMaterialesBarra) {
        // fallback: búsqueda parcial en CodeBars
        const parcialBar = Array.from(this.listaMaterialesBarra.keys()).find(k=> k.includes(c));
        if (parcialBar) base = this.listaMaterialesBarra.get(parcialBar);
      }
      if (!base) {
        // fallback final: búsqueda parcial en ItemCode
        const keyLike = Array.from(cache.keys()).find(k=> k.includes(c));
        if (keyLike) base = cache.get(keyLike);
      }
      if (!base) {
        console.debug('[SCAN] Código no encontrado', c, 'Total codigos barras cache:', this.listaMaterialesBarra?.size);
        return false; // no existe
      }
      // Verificar nuevamente si el ItemCode (resuelto desde código de barras) ya existe
      const realItemCode = base.ItemCode;
      const existente = this.data.Detalles.findIndex(d => d.ItemCode === realItemCode);
      if (existente >= 0) {
        this.data.Detalles[existente].Quantity = (this.data.Detalles[existente].Quantity||0) + qty;
        this.cambiaDatoLinea(this.data.Detalles[existente], existente, 'CANTIDAD');
        setTimeout(()=>{
          const el = document.getElementById('qty-'+existente) as HTMLInputElement; el?.focus(); el?.select();
        },0);
        return true;
      }
      const newIndex = this.appendLineFromArticulo(base, qty);
      setTimeout(()=>{
        const el = document.getElementById('qty-'+newIndex) as HTMLInputElement; el?.focus(); el?.select();
      },0);
      return true;
    } finally {
      if (needCache) { this.cargandoCodigos = false; this.loadingMessage = this.defaultLoadingMessage; }
    }
    return false;
  }

  async onManualKeydown(ev: KeyboardEvent) {
    if (ev.key === 'Enter' || ev.key === 'Tab') {
      ev.preventDefault(); // mantener foco
      const code = (this.scanManualCode||'').trim();
      if (code) {
        await this.addManualCodeDirect(code);
        this.scanManualCode='';
      }
      setTimeout(()=> this.manualScanInputRef?.nativeElement.focus(),0);
    }
  }

  singleScan: boolean = false; // modo de escaneo rápido (mobile)
  private scanProcessing = false;
  async openScanner(single: boolean = false) {
    console.debug('[SCAN] openScanner called. single=', single);
    this.singleScan = single;
    this.scannerError = null;
    this.showScanner = true;
    this.cdr.detectChanges();

    // Timeout si el modal no aparece rápido en móviles (algunos navegadores tardan en pintar)
    const appearTimeout = new Promise<void>(resolve => setTimeout(resolve, 120));
    await appearTimeout;
    if (!this.scannerVideoRef || !this.scannerVideoRef.nativeElement) {
      
      this.showScanner = false;
      this.cdr.detectChanges();
      return this.triggerFallbackCapture();
    }

    // Advertencia pero continuamos, algunos navegadores podrían todavía bloquear por contexto no seguro
    if (location.protocol !== 'https:' && location.hostname !== 'localhost') {
      Swal.fire({ icon: 'warning', title: 'Posible bloqueo de cámara', text: 'Para usar la cámara en móvil requiere HTTPS. Intentaremos abrirla, si falla use un túnel (ngrok) o habilite HTTPS.', timer: 4500 });
    }

    const anyWindow = window as any;
    if ('BarcodeDetector' in window) {
      try { this.barcodeDetector = new anyWindow.BarcodeDetector({ formats: ['code_128','ean_13','ean_8','code_39','upc_a','upc_e','itf'] }); } catch { try { this.barcodeDetector = new anyWindow.BarcodeDetector(); } catch {} }
    } else {
      
    }
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.scannerError = 'Cámara no soportada';
        
        return; // dejamos modal visible con mensaje
      }
      this.mediaStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: 'environment' } } });
      const video = this.scannerVideoRef?.nativeElement;
      if (video) { video.srcObject = this.mediaStream as any; await video.play(); }
    } catch (e) {
      const name = (e && (e as any).name) || '';
      if (name === 'NotAllowedError') this.scannerError = 'Permiso denegado por el usuario.';
      else if (name === 'NotFoundError') this.scannerError = 'No se encontró cámara disponible.';
      else this.scannerError = 'No se pudo abrir la cámara.';
      
      return; // mantenemos modal con mensaje y posibilidad de cerrar
    }
    if (this.barcodeDetector) this.scanLoop();
  }
  private async scanLoop() {
    if (!this.showScanner || !this.barcodeDetector) return;
    const video = this.scannerVideoRef?.nativeElement;
    if (video && video.readyState >= 2) {
      try {
        const results = await this.barcodeDetector.detect(video);
        if (results && results.length) {
          const code = results[0].rawValue || results[0].displayValue || '';
          if (code) {
            if (this.singleScan) {
              await this.handleScanResult(code);
              return; // detener loop tras manejar
            } else {
              this.addCodeToBuffer(code);
            }
          }
        }
      } catch {}
    }
    setTimeout(()=>this.scanLoop(), 200);
  }
  closeScanner() {
    this.showScanner = false;
    this.scannerError = null;
    this.singleScan = false;
    this.scanProcessing = false;
    try { const v = this.scannerVideoRef?.nativeElement; if (v) { v.pause(); v.srcObject = null; } } catch {}
    if (this.mediaStream) { this.mediaStream.getTracks().forEach(t=>t.stop()); this.mediaStream = null; }
  }

  // Maneja resultado de un único escaneo en modo singleScan
  private async handleScanResult(code: string) {
    if (this.scanProcessing) return; // evitar duplicados
    this.scanProcessing = true;
    const ok = await this.addManualCodeDirect(code);
    this.closeScanner();
    if (!ok) {
      Swal.fire({ icon: 'warning', title: 'Producto no encontrado', text: `Código: ${code}`, timer: 2200, showConfirmButton: false });
    }
  }

  // Fallback: usar input capture si cámara embebida falla
  triggerFallbackCapture() {
    try {
      if (this.fallbackCaptureRef?.nativeElement) {
        this.fallbackCaptureRef.nativeElement.click();
      } else {
        Swal.fire({ icon: 'error', title: 'No se pudo iniciar escaneo', text: 'Intente actualizar la página o usar un navegador compatible.' });
      }
    } catch(e){  }
  }

  async onFallbackCaptureChange(ev: Event) {
    const input = ev.target as HTMLInputElement;
    const file = input.files && input.files[0];
    if (!file) return;
    // Podríamos implementar decodificación via librería (quagga/jsQR); por ahora pedimos texto manual.
    const { value: code } = await Swal.fire({ title: 'Ingrese código', input: 'text', inputLabel: 'No se pudo leer automáticamente. Escriba el código de barras:', showCancelButton: true});
    if (code) {
      const ok = await this.addManualCodeDirect(code);
      if (!ok) Swal.fire({ icon:'warning', title:'Producto no encontrado', text:`Código: ${code}` });
    }
    input.value = '';
  }

  // Commit buffered scans into lines, aggregating duplicate codes as quantity
  async commitScannedLines() {
    if (this.scannedBuffer.size === 0) return;
    // Mostrar indicador de carga de códigos mientras se resuelven y agregan
    this.loadingMessage = this.codeLoadingMessage;
    this.cargandoCodigos = true;

    // Asegura caches precargadas (ItemCode + CodeBars) - evita reconsultar BD cada commit
    await this.ensureListaMaterialesCache();
    const byItem = this.listaMaterialesCache || new Map<string, any>();
    const byBar = this.listaMaterialesBarra || new Map<string, any>();

    let lastChangedIndex = -1;
    for (const [code, count] of this.scannedBuffer.entries()) {
      if (!count) continue;
      const rawCode = (code||'').trim();
      if (!rawCode) continue;

      // Resolución similar a addManualCodeDirect
      let base = byBar.get(rawCode) || byItem.get(rawCode);
      // Heurística numérica con padding sin y con ceros
      if (!base && /^\d+$/.test(rawCode)) {
        const conCeros = rawCode.padStart(13,'0');
        base = byBar.get(conCeros) || base;
      }
      // Búsqueda parcial en códigos de barra
      if (!base && byBar.size) {
        const parcialBar = Array.from(byBar.keys()).find(k => k.includes(rawCode));
        if (parcialBar) base = byBar.get(parcialBar);
      }
      // Búsqueda parcial en ItemCode
      if (!base && byItem.size) {
        const parcialItem = Array.from(byItem.keys()).find(k => k.includes(rawCode));
        if (parcialItem) base = byItem.get(parcialItem);
      }
      if (!base) {
        console.debug('[SCAN][commit] Código no encontrado en cache', rawCode);
        continue; // desconocido
      }

      // Determinar ItemCode real del registro encontrado
      const realItem = base.ItemCode;
      const existingIndex = this.data.Detalles.findIndex(d => d.ItemCode === realItem);
      if (existingIndex >= 0) {
        // Increase quantity on existing line
        this.data.Detalles[existingIndex].Quantity = (this.data.Detalles[existingIndex].Quantity || 0) + count;
        // Recalculate line totals & factor multiples
        this.cambiaDatoLinea(this.data.Detalles[existingIndex], existingIndex, 'CANTIDAD');
        lastChangedIndex = existingIndex;
      } else {
        // Create single new line with aggregated quantity
        const newIndex = this.appendLineFromArticulo(base, count);
        lastChangedIndex = newIndex;
      }
    }
    this.scannedBuffer.clear();
    // Focus last changed line's quantity input
    if (lastChangedIndex >= 0) {
      setTimeout(()=>{
        const el = document.getElementById('qty-' + lastChangedIndex) as HTMLInputElement;
        el?.focus();
        el?.select();
      }, 0);
    }
  this.cargandoCodigos = false;
  }

  private appendLineFromArticulo(data: any, quantity: number = 1): number {
    // Compute next key
    let maxKey = this.data.Detalles.length.toString();
    this.data.Detalles.forEach(e=>{ if (Number(e.key) >= Number(maxKey)) maxKey = (Number(e.key)+1).toString(); });
    // Base detail from ListaMateriales record, mirroring listaArticulo mapping and addLine defaults
    const detalle: any = {
      key: maxKey,
      LineNum: -1,
      BaseEntry: -1,
      BaseLine: -1,
      BaseType: null,
      Account: null,
      VATLiable: data.VATLiable,
      ItemCode: data.ItemCode,
      Dscription: data.ItemName,
      Factor1: data.SalFactor1,
      Factor2: data.SalFactor2,
      FrgnName: data.FrgnName,
      Price: (this.data.Currency !== 'CLP' ? (data.PriceOther ?? data.Price) : data.Price) ?? 0,
      Disc: 0,
      OnHand: data.OnHand,
      WhsCode: this.defaultWarehouseCode || data.DfltWH,
      Currency: this.data.Currency !== 'CLP' ? this.data.Currency : (data.Currency || 'CLP'),
      Quantity: quantity,
      ManSerNum: data.ManSerNum,
      ManBtchNum: data.ManBtchNum,
      PrecioOG: data.Price,
      CurrencyOG: data.Currency,
      SalUnitMsr: data.SalUnitMsr,
      BuyUnitMsr: data.BuyUnitMsr,
      DimCode1: null,
      DimCode2: null,
      DimCode3: null,
      DimCode4: null,
      DimCode5: null,
      Lote: [],
      Serie: [],
      CantidadPickeada: 0,
      CantidadPendiente: quantity,
      UserFields: [
        { Field:'U_IND_TIPO', FieldType:'String', Value:data.U_IND_TIPO },
        { Field:'U_IND_WMS_ESTADO', FieldType:'String', Value:'T' },
        { Field:'U_IND_SWW', FieldType:'String', Value:data.U_IND_SWW },
      ],
      ocultaLote: this.data.ObjType==='17' ? data.ManBtchNum!=='Y' : true,
      ocultaSerie: this.data.ObjType==='17' ? data.ManSerNum!=='Y' : true,
      TaxCode: data.TaxCode || data.VatGourpSa || data.VatGroupSa || this.TaxCode
    };
    // Si estamos generando Factura (13) con base en NV seleccionada, setear BaseType/BaseEntry
    if (String(this.data.ObjType) === '13' && this.baseNVEntry && this.baseNVEntry > 0) {
      detalle.BaseType = '17'; // Pedido/Nota de Venta
      detalle.BaseEntry = this.baseNVEntry;
    }

    if (this.data.Currency === 'CLP' && data.Currency !== 'CLP' && data.Currency === 'USD' && this.tipoCambio) {
      detalle.Price = data.Price * this.tipoCambio;
    }
    const isCLP = this.data.Currency === 'CLP' || !this.data.Currency;
    if (isCLP) {
      detalle.Price = redondear(detalle.Price, this.priceDec);
      this.sincronizaBrutoLinea(detalle);
    }
    // Calcular campos dependientes de precio / cantidad
    const precioUnitarioTrasDesc = detalle.Price - ((detalle.Price * (detalle.Disc || 0)) / 100);
    detalle.PriceAfeterDisc = isCLP ? precioTrasDescuento(detalle.Price, detalle.Disc, this.priceDec) : Math.round((precioUnitarioTrasDesc + Number.EPSILON) * 100) / 100;
    detalle.LineTotal = isCLP ? totalLinea(detalle.Price, detalle.Disc, detalle.Quantity) :Math.round((precioUnitarioTrasDesc * detalle.Quantity + Number.EPSILON) * 100) / 100;
    detalle._lastNetPrice = detalle.Price;
    // Guardar valores originales para reglas posteriores (liquidación, etc.)
    detalle.PriceOriginal = detalle.Price;
    detalle.DiscOriginal = detalle.Disc;
    detalle.PriceAfeterDiscOriginal = detalle.PriceAfeterDisc;
    // Push
    this.data.Detalles = [ ...this.data.Detalles, detalle ];
    this.UpdateTaxCode();
    return this.data.Detalles.length - 1; // return index of new line
  }


  LoadOC(event) {

    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);


    reader.onload = () => {

      const encodedFile = reader.result?.toString().split(',')[1];
      this.data.OCBase64 = encodedFile;

    }

    this.data.OCBase64Nombre = file.name;
    //Imágenes:
    if (file.type == "image/jpeg") {
      this.data.OCBase64Formato = ".jpg";
    }
    if (file.type == "image/png") {
      this.data.OCBase64Formato = ".png";
    }
    if (file.type == "image/gif") {
      this.data.OCBase64Formato = ".gif";
    }
    if (file.type == "image/bmp") {
      this.data.OCBase64Formato = ".bmp";
    }
    if (file.type == "image/webp") {
      this.data.OCBase64Formato = ".webp";
    }

  //Documentos:
    if (file.type == "application/pdf") {
      this.data.OCBase64Formato = ".pdf";
    }
    if (file.type == "application/msword") {
      this.data.OCBase64Formato = ".doc";
    }
    if (file.type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
      this.data.OCBase64Formato = ".docx";
    }
    if (file.type == "application/vnd.ms-powerpoint") {
      this.data.OCBase64Formato = ".ppt";
    }
    if (file.type == "application/vnd.openxmlformats-officedocument.presentationml.presentation") {
      this.data.OCBase64Formato = ".pptx";
    }

    //Hojas de cálculo:

    if (file.type == "application/vnd.ms-excel") {
      this.data.OCBase64Formato = ".xls";
    }
    if (file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      this.data.OCBase64Formato = ".xlsx";
    }


  }

  peruApi:any = false;

  async aplicaID(){
    await this._dbService.getByID(variableGlobal.DB_TABLE_GENERAL, variableGlobal.DB_TABLE_GENERAL_id_login).subscribe(
      async item => {
        var itemx:any = item;
        let login = itemx.datos.login;
              
        if (this.data.DocEntry) {
          this.data.ID_USUARIO_MODIFICACION = login._id;
        }
        else
        {
          this.data.ID_USUARIO = login._id;
        }

        

      }
    )
  }

  async ngOnInit(): Promise<void> {

    // Salvaguarda Anti-Pánico: verificar si quedó un cobro previo aprobado sin asociar a documento
    this.verificarCobroRescate();

    this.BodegaEditable = true;

    this.columnsCopy = [
      { key: 'ItemCode', title: "Articulo", cellTemplate: this.frmItemCode },
      //{ key: 'FromCode', title: "Código de proveedor", cellTemplate: this.frmFrgnName },
      { key: 'Dscription', title: 'Descripción', cellTemplate: this.frmDscription },
      { key: 'Quantity', title: 'Cantidad', cellTemplate: this.frmQuantity },
      //{ key: 'SalUnitMsr', title: 'U. Medida', cellTemplate: this.frmSalUnitMsr },
      { key: 'WhsCode', title: 'Bodega', cellTemplate: this.frmWhsCode },
      { key: 'TaxCode', title: 'Impuesto', cellTemplate: this.frmTaxCode },
      { key: 'Price', title: 'Precio', cellTemplate: this.frmPrice },
      { key: 'Disc', title: 'Dsc.', cellTemplate: this.frmDisc },
      { key: 'PriceAfeterDisc', title: 'Pre.Un.Trs.Des', cellTemplate: this.frmPriceAfeterDisc },
      { key: 'LineTotal', title: 'T.Net.', cellTemplate: this.frmLineTotal },
      { key: 'accion', title: 'Acción', cellTemplate: this.frmAccion },
    ];

    this.columns = this.columnsCopy;

    this.columnsCopy.forEach(element => {
      this.checked.add(element.key);
    });

    this.configuration = {
      ...DefaultConfig,
      searchEnabled: false,
      detailsTemplate: true,
      paginationRangeEnabled: false,
      paginationEnabled: false,
      horizontalScroll: true,
      resizeColumn: false,
      orderEnabled: false,
      rowReorder: false,
      columnReorder: false,
      fixedColumnWidth: false,
      rows: 9999
    };

    // Parallelize independent initial calls (Oportunidades + UNDTIPO only if editing)
    const initPromises: Promise<any>[] = [this.cargaOportunidades()];
    // cargaUNDTIPO solo es útil cuando hay Detalles cargados (modo editar),
    // en modo crear (Detalles=[]) la query ListaMateriales es desperdiciada
    if (this.data.Detalles && this.data.Detalles.length > 0) {
      initPromises.push(this.cargaUNDTIPO());
    }
    await Promise.all(initPromises);

    // Main data load (depends on Oportunidades in some flows, heavily sequential internally)
    await this.cargaDatosIniciales();

    // Nota: Para Factura (ObjType 13) ya no se fuerza selección de NV base al iniciar.
    // El usuario puede usar el botón "Seleccionar NV" en la UI cuando lo requiera.

    // Preload ListaMateriales + cargar datos de cliente default en paralelo
    this.traeArchivos();
    this.obtieneCodTransworld(); // fire-and-forget, el template usa listaCodigoTransworld

    this.monedaLocal = "CLP";
    if (environment.RUTA_API.includes("peru")) {
      this.monedaLocal = "S/";
      this.data.Currency = 'S/';
    }

    // Paralelizar: cargaDAtosAlTenerSocio y cache articulos son independientes
    const pSocio = ((this.data?.DocEntry == null || this.data.DocEntry < 0) && !this.data.CardCode)
      ? (async () => {
          const clienteDef = (this.OCRD || []).find((c: any) => c.CardCode === '0-0C');
          if (clienteDef) {
            this.data.CardCode = clienteDef.CardCode;
            this.data.CardName = clienteDef.CardName;
            await this.cargaDAtosAlTenerSocio();
          }
        })()
      : Promise.resolve();
    const pCache = this.ensureListaMaterialesCache();
    const [, cache] = await Promise.all([pSocio, pCache]);

    this.data.Detalles.forEach(element => {
      // Fast lookup in Map O(1) instead of iterating Array O(N)
      const articulo = cache.get(element.ItemCode);
      if (articulo) {
        element.Factor1 = articulo.SalFactor1;
        element.Factor2 = articulo.SalFactor2;
        // FrgnName desde cache en lugar de query separada
        if (articulo.FrgnName) element.FrgnName = articulo.FrgnName;
      }
    });

    this.aplicaID();

    if (this.data.ObjType == "234000031") {
      this.data.DocDueDate = new Date();
    }

    // Si es documento nuevo (DocEntry -1 o null), setear Fecha Estimada Entrega a hoy
    if ((this.data.DocEntry == null || this.data.DocEntry < 0) && !this.data.DocDueDate) {
      this.data.DocDueDate = new Date();
    }

    this.data.Detalles.forEach(element => {
      if (!element.ShipDate) {
        element.ShipDate = new Date()
      }
      element.ShipDate = this.convertToDateInputFormat(element.ShipDate)
    });

  }

  // Permite seleccionar una NV (ORDR) para usar como base en Factura (ObjType 13)
  async seleccionarOrdenVentaBase() {
    try {
      let where = "T0.[DocStatus] = 'O'"; // solo abiertas
      if (this.data.CardCode) {
        where += ` AND T0.[CardCode] = '${this.data.CardCode}'`;
      }
      const baseSelect = `SELECT TOP 200 T0.[DocEntry], T0.[DocNum], T0.[DocDate], T0.[DocDueDate], T0.[CardCode], T0.[CardName], T0.[DocTotal], T0.[DocCur], T0.[DocStatus]
                          FROM [ORDR] T0`;
      let queryFiltered = `${baseSelect} WHERE ${where} ORDER BY T0.[DocDate] DESC`;
      let finalQuery = queryFiltered;

      // Prefetch para evitar abrir un modal vacío: si con CardCode no hay resultados, usar sin filtro
      try {
        const test: any = await this._api.GetNotFileQuery(queryFiltered);
        const rows: any[] = (test && test.objeto) ? test.objeto : [];
        if ((!test || test.estado === false || rows.length === 0) && this.data.CardCode) {
          const unfiltered = `${baseSelect} WHERE T0.[DocStatus] = 'O' ORDER BY T0.[DocDate] DESC`;
          finalQuery = unfiltered;
        }
      } catch {}

      let ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,
        size: 'xl',
        scrollable: true
      };
      const modalRef = this.modalService.open(abreTablaGenericoComponent, ngbModalOptions);
      modalRef.componentInstance.query = finalQuery;
      modalRef.componentInstance.titulo = 'Seleccione Orden de Venta (NV) base';
      modalRef.componentInstance.allowSelectBtn = true;
      modalRef.componentInstance.presetColumns = [
        { key: 'DocNum', title: 'N°', width: '100px' },
        { key: 'DocDate', title: 'Fecha', width: '120px' },
        { key: 'CardName', title: 'Cliente', width: '350px' },
        { key: 'DocCur', title: 'Moneda', width: '80px' },
        { key: 'DocTotal', title: 'Total' },
      ];
      const row = await modalRef.result.catch(() => null);
      if (row && row.DocEntry != null) {
        this.baseNVEntry = Number(row.DocEntry);
        this.baseNVDocNum = Number(row.DocNum ?? 0) || null;
        this.aplicarBaseAActuales();
      } else {
        await Swal.fire('Atención', 'No se seleccionó una NV base. Puede continuar, pero BaseType/BaseEntry no se asignarán.', 'info');
      }
    } catch {}
  }

  // Aplica BaseType=17 y BaseEntry a todas las líneas actuales si corresponde
  private aplicarBaseAActuales() {
    if (String(this.data.ObjType) !== '13' || !this.baseNVEntry || this.baseNVEntry <= 0) return;
    this.data.Detalles = this.data.Detalles.map(det => ({
      ...det,
      BaseType: '17',
      BaseEntry: this.baseNVEntry,
    }));
  }

  disabledColumna(key:any)
  {
    this.columnsCopy.forEach(element => {
      if (element.key == key) {
        element.disabled = true;
      }
    });
  }

  async traeArchivos(){
    let Archivos:any = await this._api.GetNotFileQuery('SELECT * FROM ATC1 WHERE [AbsEntry] = '+this.data.AtcEntry);
    this.Archivos = Archivos.objeto;
    
    
  }

  async cargaOportunidades(){
    let query = await this.obtieneQueryMongo('Oportunidades');
    this.oportunidades = await this._api.GetNotFileQuery(query);
    this.oportunidades = this.oportunidades.objeto;

  }

  @ViewChild('CardCode') CardCode!: ElementRef<HTMLInputElement>;
  async validarSocioSeleccionado() {
    var socioEncontrado: boolean = false;
    await this.OCRD.forEach(async element => {
      if (this.data.CardCode == element.CardCode) {
        socioEncontrado = true;
      }
    });
    if (!socioEncontrado) {
      this.CardCode.nativeElement.focus();
      this.data.CardCode = "";
      Swal.fire("Mensaje", "Debes ingresar un cliente correcto", "error");
    }
    else {
      this.cargaDAtosAlTenerSocio();
    }

  }

  filtraSocio() {
    this.OCRDCopy = [];

    this.OCRD.forEach(element => {
      if (element.CardName.toUpperCase().includes(this.data.CardCode.toUpperCase())) {

        this.OCRDCopy.push(element);
      }
    });
  }

  async cambioTipoMoneda(desdeSelect: boolean = false) {




    if (this.data.Currency != this.monedaLocal) {

      

      var query: string = await this.obtieneQueryMongo("tipoCambioTodo");

      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      var fechaStr: string = yyyy + "-" + mm + "-" + dd;
      //var fechaStr:string = "2023-09-10";
      query = query + " WHERE [RateDate] = '" + fechaStr + "' AND [Currency] = '" + this.data.Currency + "'";
      var data: any = await this._api.GetNotFileQuery(query);
      if (data.objeto.length > 0) {
        var Rate = data.objeto[0].Rate;
        if (Rate > 0) {
          this.tipoCambio = Rate;
          
        }
        else {
          Swal.fire("Mensaje", "Tipo de cambio " + this.data.Currency + " no esta cargado en SAP, favor solicitar carga de este", "error");
        }
      }
      else {
        Swal.fire("Mensaje", "Tipo de cambio " + this.data.Currency + " no esta cargado en SAP, favor solicitar carga de este", "error");
      }



    }
    else {

      
      this.tipoCambio = 1;
    }


  if (desdeSelect) {
      //cambiar cositas

      var promesa = new Promise((resolve, rejects) => {

        this.data.Detalles.forEach(async element => {


          if (this.data.Currency == element.CurrencyOG) {
            element.Currency = this.data.Currency;
            element.Price = this.data.Currency == 'CLP' ? redondear(element.PrecioOG, this.priceDec) : element.PrecioOG;
            if (this.data.Currency == 'CLP') {
              this.sincronizaBrutoLinea(element);
            }
            element.Disc = 0;
            element.PriceAfeterDisc = element.Price;
          } else {
            let currency = this.data.Detalles[0].Currency;
            if (this.data.Currency == "CLP") {
              var elementCurrency = element.Currency;

              let oRate = await (this.GetRates(elementCurrency));

              element.Price = Math.round(element.Price * oRate);
              element.Currency = this.data.Currency;
              element.PriceAfeterDisc = element.Price;

            } else {
              if (element.Currency != 'CLP') {
                let oRate = await (this.GetRates(element.Currency));
                element.Price = element.Price * oRate;
              }
              element.Price = Math.round(((element.Price / this.tipoCambio) + Number.EPSILON) * 100) / 100;
              element.PriceAfeterDisc = element.Price;
              element.Currency = this.data.Currency;

            }
          }
          if (this.data.Currency == "CLP") {
            element.LineTotal = Math.round(element.PriceAfeterDisc * (Number(element.Quantity) || 1));
          } else {
            element.LineTotal = Math.round((element.PriceAfeterDisc * (Number(element.Quantity) || 1) + Number.EPSILON) * 100) / 100;
          }
          element._lastNetPrice = element.Price;

        });
      })

      promesa.then(() => {
        this.actualizaDetalleAll();
      });
      // Moneda cambió: invalidar y recargar cache artículos
      this.listaMaterialesCache = null;
      await this.precargaListaMateriales();
    }

  }

  // --- Preload ListaMateriales2 o fallback ListaMateriales ---
  private async precargaListaMateriales() {
    try {
      // Reutilizamos ensureListaMaterialesCache para construir ambos mapas (ItemCode + CodeBars)
      await this.ensureListaMaterialesCache();
    } catch { /* silencioso */ }
  }

  async GetRates(Currency) {
    var oRate = -1;

    if (Currency != "CLP") {
      var query: string = await this.obtieneQueryMongo("tipoCambioTodo");

      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      var fechaStr: string = yyyy + "-" + mm + "-" + dd;
      //var fechaStr:string = "2023-09-10";
      query = query + " WHERE [RateDate] = '" + fechaStr + "' AND [Currency] = '" + Currency + "'";
      var data: any = await this._api.GetNotFileQuery(query);


      if (data.objeto.length > 0) {
        var Rate = data.objeto[0].Rate;
        if (Rate > 0) {
          oRate = Rate;
        }
      }
      if (oRate < 0) {
        oRate = 1;
      }
    }
    else {
      oRate = 1;
    }

    return oRate;
  }

  // TOMA URL Y DETERMINA SI CREA O ACTUALIZA
  async cargaDocumentoDesdeSAP() {
    
    if (this.DocEntry) {
      if (this.DocEntry > 0) {
        this.data.DocEntry = this.DocEntry;

        

        //Actualiza currency detalle
        var datos: any = await this._apiSap.ObtenerDocumentoMarketingLITE(this.data);
        

  if (datos.estado) {
          this.creaActualiza = "Actualizar";
          this.data = datos.resultado;

          this.data.Detalles.forEach(element => {
            element.PriceOriginal = element.Price;
            element.DiscOriginal = element.Disc;
            element.PriceAfeterDiscOriginal = element.PriceAfeterDisc;
          });
          

          this.cargaDAtosAlTenerSocio();
          

          if (this.Origen) {
            if (this.Origen == "NEW") {
              this.creaActualiza = "Crear";
              this.data.DocEntry = -1;
              this.DocEntry = -1;
            }
            else {
              var clon = { ...this.data };
              this.creaActualiza = "Crear";
              this.data.Detalles.forEach((element, rowindex) => {
                element.BaseEntry = clon.DocEntry,
                  element.BaseLine = clon.Detalles[rowindex].LineNum,
                  element.BaseType = clon.ObjType
              });
              this.data.DocEntry = -1;
              this.DocEntry = -1;
              this.data.ObjType = this.Origen;
              this.ObjType = this.Origen;
              // Si se venía con prefijo IB en la ruta y el destino es Factura (13), mantener Boleta
              if (String(this.ObjType) === '13' && String(this.data.DocSubType) !== 'IB' && String(this._activeRoute.snapshot.paramMap.get("DocEntry")||'').toUpperCase().startsWith('IB')) {
                this.data.DocSubType = 'IB';
                this.data.SubObjType = "bod_Bill" as any;
              }
              this.data.Series = -1;

              if (this.Origen == "17" || this.Origen == "540000006") {
                this.data.Detalles.forEach(element => {
                  if (element.ManBtchNum == "Y") {
                    element.ocultaLote = false;
                  }
                  if (element.ManSerNum == "Y") {
                    element.ocultaSerie = false;
                  }
                });
              }

            }
          }


        }
        else {
          Swal.fire("Mensaje", datos.mensaje, "error");
        }
      }

    }
    else {
      // Crear: no necesitamos obtener documento desde SAP
    }

    this.asignarVendedorLogueado();



    var filtro = this.objetoSAP.filter((a) => a.ObjType === this.ObjType);
    this.titulo = filtro[0].DESCRIPCION;
    if (String(this.data.ObjType) === '13' && this.data.DocSubType === 'IB') {
      this.titulo = 'Boleta';
      // Para boleta (Factura con DocSubType 'IB') se requiere SubObjType = 3
      this.data.SubObjType = "bod_Bill" as any;

    }




    /*
    if (this.ObjType.toString() == "23") {
      this.titulo = "Cotización"
    }
    else if (this.ObjType.toString() == "17") {
      this.titulo = "Nota de venta"
    }
    else if (this.ObjType.toString() == "540000006") {
      this.titulo = "Pedido interno"

    }
    else if (this.ObjType.toString() == "22") {
      this.titulo = "Pedido en transito"
    }
    else {
      this.titulo = "No controlado";
    }*/

    //cuando es crear documento
    if (this.creaActualiza == "Crear") {
      var query: string = await this.obtieneQueryMongo("numeracionDocumentos");
      if (this.data.ObjType == 17) {
        query = query + " WHERE [ObjectCode] = " + this.data.ObjType;
      }else if(this.data.ObjType == 23)
      query = query + " WHERE [ObjectCode] = " + this.data.ObjType;


      
      var data: any = await this._api.GetNotFileQuery(query);
      
      this.data.DocNum = data.objeto[0].NextNumber;

    }

    
  }
  cargaDatosDireccionDespacho(item) {


    this.DESPACHO.forEach(element => {
      if (element.Address == item) {
        this.cargaDatosDireccionDespacho2(element);
      }
    });
  }

  cargaDatosDireccionDespacho2(item) {

    this.data.AddresList.CountryS = item.Country;
    this.data.AddresList.CityS = item.City;
    this.data.AddresList.CountyS = item.County;
    this.data.AddresList.StateS = item.State;
    this.data.AddresList.StreetS = item.Street;
    this.data.AddresList.ZipCodeS = item.ZipCode;


    var Street = this.data.AddresList.StreetS;
    var City = this.data.AddresList.CityS;
    var County = this.data.AddresList.CountyS;
    if (!Street) {
      Street = "";
    }
    if (!City) {
      City = "";
    }
    if (!County) {
      County = "";
    }

    this.data.Address = Street + ", " + City + ", " + County;
  }

  async abrirLoteSerie(item: DocumentoMarketingDetalle) {

    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG
    };
    var modalRef;
    if (item.ManSerNum == "Y") {
      modalRef = this.modalService.open(listaSerieComponent, ngbModalOptions);
    }
    if (item.ManBtchNum == "Y") {
      modalRef = this.modalService.open(listaLoteComponent, ngbModalOptions);
    }
    modalRef.componentInstance.data = this.data.Detalles;
    modalRef.componentInstance.ItemCode = item.ItemCode;
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.result.then(async (data: DocumentoMarketingDetalle[]) => {
      if (data) {

        this.data.Detalles = data;
        this.actualizaDetalleAll();
      }
    }, (reason) => {
      //this.editar(item);
    });

  }

  async abrirItemDetalle(item: DocumentoMarketingDetalle) {

    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG
    };


    var queryConsulta: string;

    if (this.ObjType == 23 || this.ObjType == 17) {
      queryConsulta = await this.obtieneQueryMongo("DocumentosVentaArticulo");//
    } else {
      queryConsulta = await this.obtieneQueryMongo("DocumentosCompraArticulo");
    }

    queryConsulta = queryConsulta.replace("INPUTARTICULO", item.ItemCode);
    queryConsulta = queryConsulta.replace("INPUTBODEGA", item.WhsCode);

    const modalRef = this.modalService.open(abreTablaGenericoComponent, ngbModalOptions);
    modalRef.componentInstance.query = queryConsulta;
    modalRef.componentInstance.titulo = "Detalle ventas de articulo";
    modalRef.result.then();

  }

  // ===================== PAGOS: Modal reutilizable =====================
  abrirModalPago() {
    const opts: NgbModalOptions = { backdrop: 'static', keyboard: true, size: 'lg', scrollable: true };
    const modalRef = this.modalService.open(PagoModalComponent, opts);
    modalRef.componentInstance.documentoInfo = { CardCode: this.data.CardCode || '', CardName: this.data.CardName || '', DocDate: this.data.DocDate, DocTotalFC: this.data.DocTotal };
    if (this.pagoIntent) modalRef.componentInstance.initialIntent = this.pagoIntent;
    modalRef.result.then(
      (intent) => {
        this.pagoIntent = intent;
        this.verificarCobroRescate();
      },
      () => {
        this.verificarCobroRescate();
      }
    );
  }

  // Vista previa de pago: totales simples por método
  get pagoPreviewTotal(): number {
    let total = 0;
    if (this.pagoIntent?.transferenciaBancaria?.ammount) total += Number(this.pagoIntent.transferenciaBancaria.ammount) || 0;
    if (Array.isArray(this.pagoIntent?.cheque)) total += this.pagoIntent.cheque.reduce((s, c)=> s + (Number(c.ammount)||0), 0);
    if (this.pagoIntent?.efectivo?.ammount) total += Number(this.pagoIntent.efectivo.ammount) || 0;
    if (Array.isArray(this.pagoIntent?.tarjetaCredito)) total += this.pagoIntent.tarjetaCredito.reduce((s, t)=> s + (Number(t.ammountDue)||0), 0);
    return total;
  }
  get hasTransferencia() { return !!(this.pagoIntent?.transferenciaBancaria && Number(this.pagoIntent?.transferenciaBancaria?.ammount) > 0); }
  get hasEfectivo() { return !!(this.pagoIntent?.efectivo && Number(this.pagoIntent?.efectivo?.ammount) > 0); }
  get hasCheques() { return Array.isArray(this.pagoIntent?.cheque) && this.pagoIntent!.cheque!.length > 0; }
  get hasTarjetas() { return Array.isArray(this.pagoIntent?.tarjetaCredito) && this.pagoIntent!.tarjetaCredito!.length > 0; }
  get transferenciaAmmount() { return Number(this.pagoIntent?.transferenciaBancaria?.ammount) || 0; }
  get efectivoAmmount() { return Number(this.pagoIntent?.efectivo?.ammount) || 0; }
  get totalCheques() { return (this.pagoIntent?.cheque || []).reduce((s, c)=> s + (Number(c?.ammount)||0), 0); }
  get totalTarjetas() { return (this.pagoIntent?.tarjetaCredito || []).reduce((s, t)=> s + (Number(t?.ammountDue)||0), 0); }
  // Estructura unificada para mostrar métodos de pago (puede reutilizarse en otras vistas)
  get paymentBreakdown() {
    if (!this.pagoIntent) return [];
    const arr: { tipo:string; etiqueta:string; monto:number; cantidad?:number }[] = [];
    if (this.hasTransferencia) arr.push({ tipo:'transferencia', etiqueta:'Transferencia', monto: this.transferenciaAmmount });
    if (this.hasEfectivo) arr.push({ tipo:'efectivo', etiqueta:'Efectivo', monto: this.efectivoAmmount });
    if (this.hasCheques) arr.push({ tipo:'cheque', etiqueta:`Cheques (${this.pagoIntent?.cheque?.length})`, monto: this.totalCheques, cantidad: this.pagoIntent?.cheque?.length });
    if (this.hasTarjetas) arr.push({ tipo:'tarjeta', etiqueta:`Tarjetas (${this.pagoIntent?.tarjetaCredito?.length})`, monto: this.totalTarjetas, cantidad: this.pagoIntent?.tarjetaCredito?.length });
    return arr;
  }
  editarPago() { this.abrirModalPago(); }

  async limpiarPago() {
    if (this.hasTarjetas) {
      const confirm = await Swal.fire({
        title: '¿Quitar pago de tarjeta?',
        text: 'Si ya cobraste al cliente en la maquinita física, el cobro quedará guardado para rescate o deberás anularlo en el POS.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, quitar',
        cancelButtonText: 'Cancelar'
      });
      if (!confirm.isConfirmed) return;
    }
    this.pagoIntent = null;
  }

  // ─── Salvaguarda y Rescate Anti-Pánico de Transbank ─────────────────────────

  verificarCobroRescate() {
    try {
      const raw = localStorage.getItem('TBK_COBRO_PENDIENTE_RECUPERO');
      if (!raw) {
        this.cobroRescate = null;
        return;
      }
      const rescate: CobroTbkRescate = JSON.parse(raw);
      // TTL de 2 horas
      if (!rescate.timestamp || (Date.now() - rescate.timestamp > 2 * 60 * 60 * 1000)) {
        localStorage.removeItem('TBK_COBRO_PENDIENTE_RECUPERO');
        this.cobroRescate = null;
        return;
      }

      // Validar usuario
      const currentUserId = localStorage.getItem('ID_LOGUEADO');
      if (rescate.usuarioId && currentUserId && rescate.usuarioId !== currentUserId) {
        this.cobroRescate = null;
        return;
      }

      this.cobroRescate = rescate;
    } catch {
      this.cobroRescate = null;
    }
  }

  recuperarCobroPendiente() {
    if (!this.cobroRescate) return;
    const c = this.cobroRescate;
    const hoy = new Date().toISOString().substring(0, 10);
    const rawInfo = `${c.cardType || ''} ${c.authorizationCode || ''}`;
    const paymentMethod = TransbankService.cardTypeToPaymentMethod(c.cardType, rawInfo);
    const creditCardCode = TransbankService.cardTypeToCreditCardCode(c.cardType, rawInfo);
    const accountByMethod: Record<string, string> = { '1': '_SYS00000002266', '2': '_SYS00000002267' };

    const tarjeta: any = {
      Number: 1,
      creditCard: creditCardCode,
      account: accountByMethod[paymentMethod] || '_SYS00000002266',
      creditCardNumber: c.last4Digits || '0000',
      validUntil: hoy,
      ownerIDNumber: '',
      ownerPhone: '',
      paymentMethod,
      ammountDue: c.totalPayment,
      numerOfPayment: c.sharesNumber || 1,
      firsAmmountPayment: c.sharesAmount || c.totalPayment,
      eadAddAmmountPayment: c.sharesAmount || 0,
      voucherNumebr: c.authorizationCode || '',
      transactionType: 'S',
      splitCreditVoucher: false
    };

    this.pagoIntent = {
      tarjetaCredito: [tarjeta],
      efectivo: null,
      cheque: null,
      transferenciaBancaria: null
    };

    Swal.fire({
      icon: 'success',
      title: 'Cobro de tarjeta vinculado',
      text: `Se vinculó el cobro de $${Number(c.totalPayment).toLocaleString('es-CL')} (Voucher #${c.authorizationCode}). Ya puedes presionar Crear para generar el documento en SAP sin cobrar nuevamente.`,
      timer: 4500,
      showConfirmButton: false
    });
  }

  async descartarCobroPendiente() {
    const res = await Swal.fire({
      title: '¿Descartar cobro pendiente?',
      text: 'Asegúrate de que este cobro ya fue asociado a otra venta o anulado en la maquinita física.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, descartar',
      cancelButtonText: 'Cancelar'
    });
    if (res.isConfirmed) {
      localStorage.removeItem('TBK_COBRO_PENDIENTE_RECUPERO');
      this.cobroRescate = null;
    }
  }

  actualizaDetalleAll() {
    this.data.Detalles = [
      ...this.data.Detalles.map((obj, index) => {

        return { ...obj }

      }),
    ];
  }

  async abreDireccion(tipo) {


    var data = {
      "Street": "",
      "City": "",
      "ZipCode": "",
      "County": "",
      "State": "",
      "Country": "CL"
    }
    if (tipo == "DESPACHO") {
      data.Country = this.data.AddresList.CountryS;
      data.City = this.data.AddresList.CityS;
      data.County = this.data.AddresList.CountyS;
      data.State = this.data.AddresList.StateS;
      data.Street = this.data.AddresList.StreetS;
      data.ZipCode = this.data.AddresList.ZipCodeS;
    }
    else if (tipo == "FACTURA") {
      data.Country = this.data.AddresList.CountryB;
      data.City = this.data.AddresList.CityB;
      data.County = this.data.AddresList.CountyB;
      data.State = this.data.AddresList.StateB;
      data.Street = this.data.AddresList.StreetB;
      data.ZipCode = this.data.AddresList.ZipCodeB;
    }


    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "lg",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG
    };
    const modalRef = this.modalService.open(listaDireccionComponent, ngbModalOptions);
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.result.then(async (data) => {
      if (data) {



        if (tipo == "DESPACHO") {
          this.data.AddresList.CountryS = data.Country;
          this.data.AddresList.CityS = data.City;
          this.data.AddresList.CountyS = data.County;
          this.data.AddresList.StateS = data.State;
          this.data.AddresList.StreetS = data.Street;
          this.data.AddresList.ZipCodeS = data.ZipCode;

          this.cargaDatosDireccionDespacho2(data);
        }
        else if (tipo == "FACTURA") {
          this.data.AddresList.CountryB = data.Country;
          this.data.AddresList.CityB = data.City;
          this.data.AddresList.CountyB = data.County;
          this.data.AddresList.StateB = data.State;
          this.data.AddresList.StreetB = data.Street;
          this.data.AddresList.ZipCodeB = data.ZipCode;
        }

        this.data = { ...this.data };

      }
    }, (reason) => {
      //this.editar(item);
    });
  }

  ocultaColumna(name: string): void {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions

    this.checked.has(name) ? this.checked.delete(name) : this.checked.add(name);
    this.columns = this.columnsCopy.filter((column) => this.checked.has(column.key));
  }

  convertToDateInputFormat(dateString: any) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  validaColumnaValidaInicio(key) {
    var respuesta: boolean = false;
    this.columns.forEach(element => {
      if (element.key == key) {
        respuesta = true;
      }
    });

    return respuesta;
  }

  async selecionarCliente() {
    
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG
    };
    const modalRef = this.modalService.open(listaClienteComponent, ngbModalOptions);
    modalRef.componentInstance.PriceList = this.data.ListaDePrecioSocio;
    modalRef.componentInstance.Encabezado = this.data;
    //modalRef.componentInstance.data = this.OCRD;
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.result.then(async (data) => {
      if (data) {
        this.cargaDAtosAlTenerSocio();
      }
    }, (reason) => {
      //this.editar(item);
    });

  }

  async seleccionarDocHisto() {

    let dataEnviar = {
      "ObjType": this.data.ObjType,
      "CardCode":this.data.CardCode
    }
    
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG
    };
    const modalRef = this.modalService.open(ListahistorialdevolucionComponent, ngbModalOptions);
    modalRef.componentInstance.data = dataEnviar;
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.componentInstance.Encabezado = this.data;
    modalRef.componentInstance.TaxCode = this.TaxCode;
    modalRef.result.then(async (data) => {
      if (data) {
        this.data.Detalles = [...this.data.Detalles,...data]
      }
    }, (reason) => {
      //this.editar(item);
    });
    
  }

  async CargarDatosClienteCuentas() {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG
    };

    const modalRef = this.modalService.open(CuentasSocioComponent, ngbModalOptions);

    modalRef.componentInstance.CardCode = this.data.CardCode;
    modalRef.componentInstance.modalReference = modalRef;

    modalRef.result.then(async (data) => {
      if (data) {

        //cargar datos ahroa que tengo cliente

      }
    }, (reason) => {
      //this.editar(item);
    });
  }





  HidePur() {
    if (this.ObjType.toString() == "540000006") {
      return true;
    } else {
      return false;
    }
  }


  async cargaDAtosAlTenerSocio() {

    this.cargando = true;


    /*
    if (!this.Origen) {
      this.OCRD.forEach(element => {
        if (element.CardCode == this.data.CardCode) {
          this.data.CardName = element.CardName;
          this.data.DescuentoCampoUsuario = element.U_Descuento;
          this.data.ShipToDef = element.ShipToDef;
          this.data.BillToDef = element.BillToDef;
          this.data.ListaDePrecioSocio = element.ListNum;
          this.data.GroupNum = element.GroupNum;
          this.data.Currency = element.Currency;
          this.data.ListaCUrrency = false;
          if (this.data.Currency  == "##") {
            this.data.Currency = "USD";
            this.data.ListaCUrrency = true;
          }
        }
      });
    }*/

    var objeto = "SELECT * FROM [CRD1] WHERE [CardCode] = '" + this.data.CardCode + "'";
    var dato: any = await this._api.GetNotFileQuery(objeto);
    dato = dato.objeto;
    this.DESPACHO = [];
    this.FACTURA = [];

    dato.forEach(element => {
      if (element.AdresType == "S") {
        this.DESPACHO.push(element);

      }
      else if (element.AdresType == "B") {
        this.FACTURA.push(element);
      }
    });

    this.DESPACHO.forEach(element => {
      if (this.data.ShipToDef == element.Address) {
        this.cargaDatosDireccionDespacho2(element);
      }
    });


    if (environment.RUTA_API.includes("peru") && this.data.Currency == 'CLP') {
      this.data.Currency = 'S/';
    }

    this.oportunidadSeleccionada = null;

    

    this.oportunidadesView = this.oportunidades.filter( item => item.CardCode == this.data.CardCode);

    // Paralelizar fetch de oportunidades
    if (this.oportunidadesView.length > 0) {
      const oportunidadPromises = this.oportunidadesView.map(element =>
        this._apiSap.obtieneOportunidad(element.OpprId)
      );
      const results: any[] = await Promise.all(oportunidadPromises);
      this.oportunidadesFiltrados = results.map(res => res.resultado);
    }

    

    await this.cambioTipoMoneda();

    this.cargando = false;

  }

  removeRow(rowIndex: number): void {

    Swal.fire({
      title: "¿Está seguro que desea eliminar la linea?",
      showDenyButton: true,
      showCancelButton: false,
      denyButtonText: "Cerrar",
      confirmButtonText: "Si",

    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        this.deleteRow(rowIndex);

      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })

  }

  async textoDirDespacho() {
    var respuesta = "";
    this.TaxCode = "ILA";

    if (this.DESPACHO) {
      this.DESPACHO.forEach(element => {
        if (element.Address == this.data.ShipToDef) {
          this.cargaDatosDireccionDespacho2(element);
          this.TaxCode = element.TaxCode;
          var Street = element.Street;
          var City = element.City;
          var County = element.County;
          if (!Street) {
            Street = "";
          }
          if (!City) {
            City = "";
          }
          if (!County) {
            County = "";
          }

          respuesta = Street + ", " + City + ", " + County;
        }
      });
    }
    this.actualizaImpuesto();
    return respuesta;
  }

  actualizaImpuesto() {

    if (this.data.GroupCode == "104") {

      this.TaxCode = "IVA_EXE";
    } else {
      // this.TaxCode = "IVA";
    }
    this.data.Detalles.forEach(element => {
      element.TaxCode = this.TaxCode;
    });
    this.UpdateTaxCode();
  }


  textoDirFactura() {
    var respuesta = "";
    if (this.FACTURA) {
      this.FACTURA.forEach(element => {
        if (element.Address == this.data.BillToDef) {
          var Street = element.Street;
          var City = element.City;
          var County = element.County;
          if (!Street) {
            Street = "";
          }
          if (!City) {
            City = "";
          }
          if (!County) {
            County = "";
          }

          respuesta = Street + ", " + City + ", " + County;
        }
      });
    }
    return respuesta;
  }

  probandoCarga: boolean = false;
  async cargaDatosIniciales() {

    if (!this.probandoCarga) {
      Swal.fire({
        title: 'Espere por favor!',
        html: 'Se está cargando documento',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading()
        },
      });
    }

    // 1. Parallelize independent requests
    const pObjetosSAP = this._apiMongo.getObjetosSAP();
    const pOSTC = this._api.GetNotFileQuery("SELECT [Code], [Rate] FROM [OSTC]");
    const pOHEM = this._api.GetNotFileQuery("SELECT [empID], [lastName], [firstName] FROM [OHEM] WHERE [Active] = 'Y' ORDER BY [lastName] ASC");
    const pOSLP = this._api.GetNotFileQuery("SELECT [SlpCode], [SlpName] FROM [OSLP] WHERE [Active] = 'Y' ORDER BY [SlpName] ASC");
    const pOITM = this._api.GetNotFileQuery("SELECT [FrgnName],[ItemCode] FROM OITM");
    const pOCRN = this._api.GetNotFileQuery("SELECT [CurrCode], [CurrName] FROM [OCRN] ORDER BY [CurrCode] ASC");
    const pOCTG = this._api.GetNotFileQuery("SELECT [GroupNum], [PymntGroup] FROM [OCTG] ORDER BY [PymntGroup] ASC");
    const pOSHP = this._api.GetNotFileQuery("SELECT [TrnspCode], [TrnspName] FROM [OSHP]");
    const pOWHS = this._api.GetNotFileQuery("SELECT [WhsCode], [WhsName] FROM [OWHS] WHERE [Inactive] = 'N'");
    // Decimales de precio de SAP; si la consulta falla se trabaja con precios enteros (comportamiento seguro)
    const pDecimales = this._api.GetNotFileQuery("SELECT T0.[PriceDec], (SELECT T1.[Decimals] FROM [OCRN] T1 WHERE T1.[CurrCode] = 'CLP') AS [DecimalesCLP] FROM [OADM] T0").catch(() => null);

    // Dependencies on obtieneQueryMongo
    const pIMPUESTOS = this.obtieneQueryMongo("IMPUESTOS").then(q => this._api.GetNotFileQuery(q));
    const pIND_Tipo_E = this.obtieneQueryMongo("ValoresTablaUsuario").then(q => this._api.GetNotFileQuery(q + " WHERE T0.[TableID] = 'ORDR' AND T0.[AliasID] = 'IND_Tipo_E'"));
    const pOCRD = this.obtieneQueryMongo("ListaClientes").then(q => this._api.GetNotFileQuery(q));

    // Wait all
    const [
      resObjetosSAP, resOSTC, resOHEM, resOSLP, resOITM, resOCRN, resOCTG, 
      resOSHP, resOWHS, resIMP, resIND, resOCRD, resDecimales
    ] : any[] = await Promise.all([
      pObjetosSAP, pOSTC, pOHEM, pOSLP, pOITM, pOCRN, pOCTG, pOSHP, pOWHS, pIMPUESTOS, pIND_Tipo_E, pOCRD, pDecimales
    ]);

    const filaDecimales = resDecimales && resDecimales.objeto && resDecimales.objeto[0];
    this.priceDec = filaDecimales ? decimalesPrecioEfectivos(filaDecimales.PriceDec, filaDecimales.DecimalesCLP) : 0;

    this.objetoSAP = resObjetosSAP.resultado;
    this.OSTC = resOSTC.objeto;
    this.OHEM = resOHEM.objeto;
    
    // OSLP Sorting
    this.OSLP = resOSLP.objeto;
    const excludedItem = this.OSLP.find(item => item.SlpCode == -1);
    const sortedData = this.OSLP
        .filter(item => item.SlpCode !== -1)
        .sort((a, b) => a.SlpName.localeCompare(b.SlpName));
    if (excludedItem) sortedData.unshift(excludedItem);
    this.OSLP = sortedData;

    this.OITMFrgnName = resOITM.objeto;
    
    // OCRN Filtering
    this.OCRN = resOCRN.objeto;
    if (this.peruApi) {
      for (let index = 0; index < this.OCRN.length; index++) {
        if (this.OCRN[index].CurrCode == "CLP") {
          this.OCRN.splice(index,1)
        }
        if (this.OCRN[index].CurrCode == "EUR") {
          this.OCRN.splice(index,1)
        }
      }
    }

    this.OCTG = resOCTG.objeto;
    this.OSHP = resOSHP.objeto;
    this.OWHS = resOWHS.objeto;
    
    // IMPUESTOS
    this.IMPUESTOS = resIMP.objeto;
    this.IMPUESTOS.forEach(element => {
      if (element.Code == this.TaxCode) {
        this.TaxRate = element.Rate;
        this.TaxName = element.Name || this.TaxCode;
      }
    });

    this.IND_Tipo_E = resIND.objeto;
    this.OCRD = resOCRD.objeto;
    this.OCRDCopy = [...this.OCRD];

    this.ObjType = this._activeRoute.snapshot.paramMap.get("ObjType");
    this.DocEntry = this._activeRoute.snapshot.paramMap.get("DocEntry");
    this.Origen = this._activeRoute.snapshot.paramMap.get("Origen");

    // Soporte a enlaces: /Venta/17/IB{DocEntry}/13 o /Venta/13/IB
    let boletaFromRoute = false;
    const rawDocEntryParam = String(this.DocEntry ?? '').trim();
    const upperDocEntryParam = rawDocEntryParam.toUpperCase();
    if (upperDocEntryParam.startsWith('IB')) {
      boletaFromRoute = true;
      const remainder = rawDocEntryParam.substring(2).trim();
      if (remainder) {
        const parsed = Number(remainder);
        if (!isNaN(parsed) && parsed > 0) {
          // Usar la parte numérica como DocEntry real (para clonar NV -> FAC cuando Origen indique 13)
          this.DocEntry = parsed as any;
        } else {
          // Prefijo IB sin número válido: creación de Boleta sin base
          this.DocEntry = null as any;
        }
      } else {
        // Solo 'IB' sin número
        this.DocEntry = null as any;
      }
    }

    this.creaActualiza = "Crear";
    this.data.ObjType = this.ObjType;
    // Caso especial: Boleta (Factura con DocSubType IB) cuando la ruta indica prefijo IB
    if (boletaFromRoute && String(this.data.ObjType) === '13') {
      this.data.DocSubType = 'IB';
      this.data.SubObjType = "bod_Bill" as any;
      this.data.DocEntry = -1;
    }

    this.disabledColumna("ItemCode");
    this.disabledColumna("Quantity");
    this.disabledColumna("Price");
    this.disabledColumna("frmCodTransworld");
    this.disabledColumna("OnHand");
    this.disabledColumna("Disc");
    this.disabledColumna("PriceAfeterDisc");
    this.disabledColumna("LineTotal");
    this.disabledColumna("accion");

    this.ocultaColumna("Factor1");
    this.ocultaColumna("ItemCodev2");
    this.ocultaColumna("Factor2");
    this.ocultaColumna("BuyUnitMsr");
    // this.ocultaColumna("PriceAfeterDisc");
    if (this.ObjType == "23" || this.ObjType == "17") {
      // this.ocultaColumna("BuyUnitMsr");
    } else {
      this.ocultaColumna("SalUnitMsr");
    }


    await this.cargaDocumentoDesdeSAP();



    if (variableGlobal.ESTILO_EASY_TABLE) {
      this.setClass(variableGlobal.ESTILO_EASY_TABLE);
    }

    if (!this.probandoCarga) {
      Swal.close();
    }

    this.CargarUsuario();
  }

  async clienteSeleccionado(CardCode: string) {

  }

  async asignarVendedorLogueado() {
    //OBTIENE VENDEDOR USUARIO LOGUEADO
    var dato: any = await this._dbService.getAll(variableGlobal.DB_TABLE_GENERAL).toPromise();
    dato = dato.filter(item => item.id == variableGlobal.DB_TABLE_GENERAL_id_login)[0];
    
    this.usuario = dato.datos.login;

    this.data.SlpCode = dato.datos.login.VENDEDOR;
    // Si el usuario tiene bodega por defecto, bloquear selección y forzarla en todas las líneas
    const bodega = (this.usuario && this.usuario.BODEGA_DEFAULT) ? String(this.usuario.BODEGA_DEFAULT).trim() : '';
    const isMultiBodega = !!(this.usuario && this.usuario.MULTI_BODEGA);

    if (bodega) {
      // Validar que exista en OWHS si ya fue cargado
      const existe = Array.isArray(this.OWHS) ? this.OWHS.some((w:any)=> String(w.WhsCode).trim() === bodega) : true;
      this.defaultWarehouseCode = existe ? bodega : null;

      if (isMultiBodega) {
        // Multi-bodega: desbloquear selección pero mantener default para líneas nuevas
        this.BodegaEditable = true;
        // Filtrar bodegas si no tiene "todas"
        if (!this.usuario.BODEGAS_TODAS && Array.isArray(this.usuario.BODEGAS_PERMITIDAS) && this.usuario.BODEGAS_PERMITIDAS.length > 0) {
          const permitidas: string[] = this.usuario.BODEGAS_PERMITIDAS;
          // Siempre incluir la bodega default en la lista
          this.OWHS = (this.OWHS || []).filter((w: any) =>
            permitidas.includes(String(w.WhsCode).trim()) || String(w.WhsCode).trim() === bodega
          );
        }
        // No forzar la bodega en líneas existentes, solo la usa como default en nuevas
      } else {
        // Comportamiento original: bloquear y forzar
        this.BodegaEditable = this.defaultWarehouseCode ? false : this.BodegaEditable;
        if (this.defaultWarehouseCode) this.enforceDefaultWarehouseOnDetails();
      }
    } else {
      this.defaultWarehouseCode = null;
      this.BodegaEditable = true;

      // Multi-bodega sin default: filtrar bodegas si aplica
      if (isMultiBodega && !this.usuario.BODEGAS_TODAS && Array.isArray(this.usuario.BODEGAS_PERMITIDAS) && this.usuario.BODEGAS_PERMITIDAS.length > 0) {
        const permitidas: string[] = this.usuario.BODEGAS_PERMITIDAS;
        this.OWHS = (this.OWHS || []).filter((w: any) => permitidas.includes(String(w.WhsCode).trim()));
      }
    }
  }

  private setClass(name: string): void {
    this.table.apiEvent({
      type: API.setTableClass,
      value: name,
    });
  }

  private _queryCache: any[] | null = null;

  async obtieneQueryMongo(nombre) {
    if (!this._queryCache) {
      const data: any = await this._api.getQueryAll();
      this._queryCache = data.objeto;
    }
    var query: string = "";
    this._queryCache.forEach(element => {
      if (element.NOMBRE == nombre) {
        query = element.CONSULTA;
      }
    });

    return query;
  }

  async ListaMateriales(item: DocumentoMarketingDetalle, rowIndex) {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG
    };
    const modalRef = this.modalService.open(listaArticuloComponent, ngbModalOptions);
    modalRef.componentInstance.PriceList = this.data.ListaDePrecioSocio;
    modalRef.componentInstance.Detalle = item;
    modalRef.componentInstance.Encabezado = this.data;
    modalRef.componentInstance.tipoCambio = this.tipoCambio;
    modalRef.componentInstance.Currency = this.data.Currency;
    modalRef.componentInstance.DefaultWhsCode = this.defaultWarehouseCode;
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.result.then((data) => {
      if (data) {
        // El modal retorna data que trae los Detalles conteniendo el itemcode
        
        const isCLP = this.data.Currency === 'CLP' || !this.data.Currency;
        if (isCLP) {
          data.Price = redondear(data.Price, this.priceDec);
          data.PriceAfeterDisc = redondear(Number(data.PriceAfeterDisc) || data.Price, this.priceDec);
          // Artículo nuevo en la fila: el precio público de la línea anterior ya no aplica
          data._grossUnitPrice = undefined;
          data._grossTyped = false;
        }
        data._lastNetPrice = data.Price;
        data.PriceOriginal = data.Price;
        data.PriceAfeterDiscOriginal = data.PriceAfeterDisc;
        data.DiscOriginal = data.Disc;
        // Si hay bodega por defecto, forzarla antes de actualizar la fila
        if (this.defaultWarehouseCode) {
          data.WhsCode = this.defaultWarehouseCode;
        }
        this.UpdateRow(data, rowIndex);

        
      }
    }, (reason) => {
      //this.editar(item);
    });
  }

  async UpdateRow(item, rowIndex, origen = "NUEVA_LINEA") {
    
    this.data.Detalles = [
      ...this.data.Detalles.map((obj, index) => {
        if (index === rowIndex) {

          // Forzar bodega por defecto si aplica
          if (this.defaultWarehouseCode) {
            obj.WhsCode = this.defaultWarehouseCode;
            if (item && item.WhsCode !== this.defaultWarehouseCode) {
              item.WhsCode = this.defaultWarehouseCode;
            }
          }

          const isCLP = this.data.Currency === 'CLP' || !this.data.Currency;

          if (origen == "PriceAfeterDisc") {
            let precio: number = Number(obj.Price) || 0;
            let precioafterdcto: number = Number(obj.PriceAfeterDisc) || 0;

            let descuento = precio > 0 ? (precioafterdcto * 100) / precio : 0;

            descuento = 100 - descuento;

            if (this.ObjType == "23") {

              if (descuento > 15) {
                obj.Disc = 0;
                obj.PriceAfeterDisc = obj.Price;
              } else {
                obj.Disc = descuento;
              }

            } else {
              obj.Disc = descuento;
            }

            obj.Disc = Math.round((obj.Disc + Number.EPSILON) * 100) / 100;
            if (isCLP) {
              obj.PriceAfeterDisc = redondear(precioafterdcto, this.priceDec);
              obj.LineTotal = totalLinea(obj.Price, obj.Disc, obj.Quantity);
            } else {
              obj.PriceAfeterDisc = Math.round((precioafterdcto + Number.EPSILON) * 100) / 100;
              obj.LineTotal = Math.round(((Number(obj.Quantity) || 0) * obj.PriceAfeterDisc + Number.EPSILON) * 100) / 100;
            }

          }
          // Si el usuario edita el precio, el precio ingresado se asume BRUTO
          // y debemos dejarlo NETO (restar los impuestos) para que luego el total lo vuelva a agregar.
          if (origen == "PRECIO") {
            // Guard contra doble blur: si el valor no ha cambiado respecto al último neto calculado, no re-dividir
            // (ni volver a tomar como precio público un valor que ya es neto)
            if (obj._lastNetPrice === undefined || obj.Price !== obj._lastNetPrice) {
              const totalRate = this.peruApi ? 0 : this.tasaTotalLinea(obj);
              if (totalRate > 0) {
                const precioBruto = Number(obj.Price) || 0;
                if (isCLP) {
                  obj._grossUnitPrice = precioBruto > 0 ? precioBruto : undefined;
                  obj._grossTyped = precioBruto > 0;
                  obj.Price = netoDesdeBruto(precioBruto, totalRate, this.priceDec);
                } else {
                  const precioNeto = precioBruto / (1 + (totalRate / 100));
                  obj.Price = Math.round((precioNeto + Number.EPSILON) * 100) / 100;
                }
              } else {
                if (isCLP) {
                  obj.Price = redondear(obj.Price, this.priceDec);
                  obj._grossUnitPrice = undefined;
                  obj._grossTyped = false;
                }
              }
              obj._lastNetPrice = obj.Price;
            }
          } else {
            if (obj.Price !== null && obj.Price !== undefined) {
              if (isCLP) {
                obj.Price = redondear(obj.Price, this.priceDec);
                this.sincronizaBrutoLinea(obj);
              }
              obj._lastNetPrice = obj.Price;
            }
          }
          if (origen == "CANTIDAD") {
            let cantidad = obj.Quantity;
            let Factor2 = obj.Factor2;
          }
          if (origen == "DESCUENTO") {

            if (this.ObjType == "23") {
              if (obj.Disc > 15) {
                obj.Disc = 15;
              }
            }
          }
          if (origen == "CAJAS") {
            obj.Quantity = obj.Factor2 * obj.Factor1;
          }
          if (origen != "PriceAfeterDisc") {
            var precioUnitarioTrasDescuneto = (Number(obj.Price) * (Number(obj.Disc) || 0)) / 100;
            precioUnitarioTrasDescuneto = Number(obj.Price) - precioUnitarioTrasDescuneto;
            var TotalDespuesDescuento = precioUnitarioTrasDescuneto * (Number(obj.Quantity) || 0);
            if (isCLP) {
              obj.PriceAfeterDisc = precioTrasDescuento(obj.Price, obj.Disc, this.priceDec);
            } else {
              obj.PriceAfeterDisc = Math.round((precioUnitarioTrasDescuneto + Number.EPSILON) * 100) / 100;
              obj.LineTotal = Math.round((TotalDespuesDescuento + Number.EPSILON) * 100) / 100;
            }
          }
          if (isCLP) {
            // SAP calcula el total de línea desde precio, cantidad y % de descuento (no desde el precio tras descuento)
            obj.LineTotal = totalLinea(obj.Price, obj.Disc, obj.Quantity);
          }

          return { ...obj }
        }
        return obj;
      }),
    ];

  }


  async cambiaDatoLinea(item: DocumentoMarketingDetalle, rowIndex, origen) {

    
    
    
    

    
    if (this.data.ObjType == '23' || this.data.ObjType == '17') {

      item.UserFields.forEach(element => {
        if (element.Field == "U_IND_TIPO") {
          if (element.Value != "Liquidacion" && element.Value != "Oferta") {
            if (item.Disc > 15) {
              item.Disc = 15
            }
          }
          else
          {
            this.liquidacion(item)
          }
        }
      });
    }


    this.UpdateRow(item, rowIndex, origen);
    this.UpdateTaxCode();
  }

  deleteRow(rowIndex) {
    this.data.Detalles = [...this.data.Detalles.filter((_v, k) => k !== rowIndex)];
  }
  addLine() {
    var maxKey = this.data.Detalles.length.toString();
    this.data.Detalles.forEach(element => {
      if (Number(element.key) >= Number(maxKey)) {
        maxKey = (Number(element.key) + 1).toString();
      }
    });


    if (this.data.GroupCode == "104") {

      this.TaxCode = "IVA_EXE";
    }

    this.data.Detalles = [
      ...this.data.Detalles,
      {
        key: maxKey,
        LineNum: null,
        BaseEntry: -1,
        BaseLine: -1,
        BaseType: null,
        Account: null,
        ItemCode: null,
        Dscription: null,
        Factor1: null,
        Factor2: null,
        Quantity: null,
        Price: null,
        Disc: this.data.DescuentoCampoUsuario,
        PriceAfeterDisc: this.data.DescuentoCampoUsuario,
        LineTotal: null,
        OnHand: null,
        TaxCode: this.TaxCode,
  WhsCode: this.defaultWarehouseCode || null,
        DimCode1: null,
        DimCode2: null,
        DimCode3: null,
        DimCode4: null,
        DimCode5: null,
        Currency: this.data.Currency,
        Lote: [],
        Serie: [],
        ManBtchNum: null,
        ManSerNum: null,
        CantidadPickeada: null,
        CantidadPendiente: null,
        ocultaLote: true,
        ocultaSerie: true,
        UserFields: [{
          Field: "U_IND_WMS_ESTADO",
          FieldType: "string",
          Value: "T",
        },

      ],
      }
    ];

  }

  UpdateTaxCode() {

    this.IMPUESTOS.forEach(element => {
      if (element.Code == this.TaxCode) {
        this.TaxRate = element.Rate;
        this.TaxName = element.Name || this.TaxCode;
      }
    });

    this.VatSum();
    
    
    
  }

  /**
   * Soft reset: limpia el documento sin recargar la página completa.
   * Reutiliza datos de referencia ya cargados (OCRD, OWHS, OSLP, etc.)
   * Solo recarga lo mínimo: numeración, vendedor, cliente default.
   */
  async softReset() {
    Swal.fire({
      title: 'Preparando nuevo documento...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading()
    });

    const previousDocSubType = this.data?.DocSubType;

    // Reset document data to defaults
    this.data = {
      OCBase64Nombre: '', OCBase64Formato: '', OCBase64: '',
      UserFields: [],
      Draft: false, SubObjType: null,
      DocEntry: -1, DocNum: -1, Rate: 1,
      CardCode: null, CardName: null, Currency: 'CLP',
      NumAtCard: null, Series: -1, DocType: 'I',
      ShipToCode: null, PayToCode: null,
      Address: null, Address2: null,
      GroupNum: null, GroupCode: null, TrnspCode: null,
      U_IND_Tipo_E: null,
      TaxDate: null, DocDueDate: null, DocDate: null,
      ObjType: this.ObjType,
      SlpCode: -1, OwnerCode: null, Comments: '',
      GrossProfit: 0, DiscPrcnt: 0, DiscTotal: 0,
      TotalExpns: 0, VatSum: 0, DocTotal: 0,
      DescuentoCampoUsuario: 10, Detalles: [],
      BillToDef: null, ShipToDef: null,
      ListaDePrecioSocio: null, ListaCUrrency: false,
      AtcEntry: -1,
      AddresList: {
        StreetS: null, StreetNoS: null, BlockS: null, CityS: null,
        ZipCodeS: null, CountyS: null, StateS: null, CountryS: null,
        BuildingS: null, Address2S: null, Address3S: null, GlbLocNumS: null,
        StreetB: null, StreetNoB: null, BlockB: null, CityB: null,
        ZipCodeB: null, CountyB: null, StateB: null, CountryB: null,
        BuildingB: null, Address2B: null, Address3B: null, GlbLocNumB: null
      }
    };

    this.creaActualiza = 'Crear';
    this.pagoIntent = null;
    this.cobroRescate = null;
    this.oportunidadSeleccionada = null;
    this.oportunidadesView = [];
    this.oportunidadesFiltrados = [];
    this.baseNVEntry = null;
    this.baseNVDocNum = null;
    this.Archivos = [];
    this.DESPACHO = [];
    this.FACTURA = [];
    this.scannedBuffer.clear();

    // Moneda local
    if (environment.RUTA_API.includes('peru')) {
      this.data.Currency = 'S/';
    }

    // Obtener nueva numeración (paralelo con asignar vendedor)
    const pNumeracion = (async () => {
      try {
        let query: string = await this.obtieneQueryMongo('numeracionDocumentos');
        if (this.data.ObjType == 17) query += ' WHERE [ObjectCode] = ' + this.data.ObjType;
        else if (this.data.ObjType == 23) query += ' WHERE [ObjectCode] = ' + this.data.ObjType;
        const numData: any = await this._api.GetNotFileQuery(query);
        this.data.DocNum = numData.objeto[0].NextNumber;
      } catch (e) {  }
    })();

    const pVendedor = this.asignarVendedorLogueado();

    await Promise.all([pNumeracion, pVendedor]);

    // Cargar cliente default 0-0C
    const clienteDef = (this.OCRD || []).find((c: any) => c.CardCode === '0-0C');
    if (clienteDef) {
      this.data.CardCode = clienteDef.CardCode;
      this.data.CardName = clienteDef.CardName;
      await this.cargaDAtosAlTenerSocio();
    }

    // Título
    const filtro = this.objetoSAP.filter((a) => a.ObjType === this.ObjType);
    if (filtro.length) this.titulo = filtro[0].DESCRIPCION;

    if (String(this.data.ObjType) === '13' && previousDocSubType === 'IB') {
      this.titulo = 'Boleta';
      this.data.DocSubType = 'IB';
      this.data.SubObjType = "bod_Bill" as any;
    }

    this.aplicaID();

    Swal.close();
    
  }

  // Fuerza WhsCode a la bodega por defecto en todas las líneas y refresca la tabla
  private enforceDefaultWarehouseOnDetails() {
    if (!this.defaultWarehouseCode || !this.data || !Array.isArray(this.data.Detalles)) return;
    let changed = false;
    this.data.Detalles.forEach(d => {
      if (d && d.WhsCode !== this.defaultWarehouseCode) {
        d.WhsCode = this.defaultWarehouseCode;
        changed = true;
      }
    });
    if (changed) this.actualizaDetalleAll();
  }

  moverIdiceTabla(posicionActual, posicionRemplaza) {

    var detalleClon: DocumentoMarketingDetalle[] = [...this.data.Detalles];
    this.data.Detalles = [];


    var orden = [];
    var vuelta: number = 0;
    detalleClon.forEach(element => {
      var key = element.key;
      var index2 = vuelta;

      if (vuelta == posicionActual) {
        index2 = posicionRemplaza;
      }
      if (vuelta == posicionRemplaza) {
        index2 = posicionActual;
      }

      var json = {
        index: vuelta,
        index2: index2,
        key: key
      }
      orden.push(json);
      vuelta++;
    });

    orden.forEach(element => {
      var detalleRow: DocumentoMarketingDetalle = detalleClon[element.index2];
      detalleRow.key = element.key;
      this.data.Detalles = [
        ...this.data.Detalles,
        detalleRow
      ]
    });



  }

  public clicked: string;
  eventEmitted($event: { event: string; value: any }): void {
    //this.clicked = JSON.stringify($event);



    if ($event.event == "onRowDrop") {
      this.moverIdiceTabla($event.value.currentIndex, $event.value.previousIndex);

    }
  }


  GrossProfit() {
    var sumDetalle: number = 0;
    const isCLP = this.data.Currency === 'CLP' || !this.data.Currency;
    this.data.Detalles.forEach(element => {
      sumDetalle += Number(element.LineTotal) || 0;
    });
    this.data.GrossProfit = isCLP ? Math.round(sumDetalle) : Math.round((sumDetalle + Number.EPSILON) * 100) / 100;
    return this.data.GrossProfit;
  }

  DiscTotal() {
    const isCLP = this.data.Currency === 'CLP' || !this.data.Currency;
    const desc = ((Number(this.data.GrossProfit) || 0) * (Number(this.data.DiscPrcnt) || 0)) / 100;
    this.data.DiscTotal = isCLP ? Math.round(desc) : Math.round((desc + Number.EPSILON) * 100) / 100;
    return this.data.DiscTotal;
  }
  cambiaInput(evento) {
    if (evento.target.name = "DiscPrcnt") {
      this.data.DiscPrcnt = Number(evento.target.value);
    }

  }
  // Decimales con que SAP conserva el precio unitario en CLP (se carga desde OADM/OCRN al iniciar)
  priceDec: number = 0;

  private esBoleta(): boolean {
    return String(this.data.ObjType) === '13' && this.data.DocSubType === 'IB';
  }

  // Tasas de impuesto de una línea, separadas como las muestra el panel de totales
  private tasasLinea(element: DocumentoMarketingDetalle): { primaryRate: number, extraIvaRate: number } {
    let lineTaxCode = element.TaxCode || this.TaxCode;
    let currentImpuesto = Number(this.getImpuestoRate(lineTaxCode)) || 0;

    let primaryRate = 0;
    let extraIvaRate = 0;

    let isOnlyIva = (currentImpuesto === 19) || (lineTaxCode === 'IVA');

    if (!(element.VATLiable == "N" || this.TaxCode == "IVA_EXE" || lineTaxCode == "IVA_EXE")) {
      if (isOnlyIva && this.TaxCode === 'ILA') {
        primaryRate = 0;
        extraIvaRate = currentImpuesto; // Mover al sumador de IVA para que cuadre con la UI
      } else if (isOnlyIva) {
        primaryRate = currentImpuesto;
        extraIvaRate = 0;
      } else {
        primaryRate = currentImpuesto; // Ej: 20.5% (separado)
        if (!this.peruApi) {
          extraIvaRate = 19;
        }
      }
    }
    return { primaryRate, extraIvaRate };
  }

  private tasaTotalLinea(element: DocumentoMarketingDetalle): number {
    const t = this.tasasLinea(element);
    return t.primaryRate + t.extraIvaRate;
  }

  // Una línea se calcula desde su precio público cuando el vendedor lo digitó o el documento es boleta
  private lineaGuiadaPorBruto(d: DocumentoMarketingDetalle): boolean {
    return !!d._grossTyped || this.esBoleta();
  }

  // Precio público vigente de la línea: el guardado si aún corresponde a su neto, o el que se deduce del neto
  private brutoVigenteLinea(d: DocumentoMarketingDetalle): { bruto: number, digitado: boolean } {
    const tasa = this.tasaTotalLinea(d);
    const neto = Number(d.Price) || 0;
    if (this.peruApi || !(tasa > 0) || !(neto > 0)) {
      return { bruto: 0, digitado: false };
    }
    if (brutoEsConsistente(Number(d._grossUnitPrice) || 0, neto, tasa, this.priceDec)) {
      return { bruto: Number(d._grossUnitPrice), digitado: !!d._grossTyped };
    }
    return { bruto: brutoDesdeNeto(neto, tasa), digitado: false };
  }

  // Deja en la línea su precio público y, si la línea manda por bruto, su neto con los decimales que admite SAP
  private sincronizaBrutoLinea(d: DocumentoMarketingDetalle): void {
    const vigente = this.brutoVigenteLinea(d);
    d._grossUnitPrice = vigente.bruto > 0 ? vigente.bruto : undefined;
    d._grossTyped = vigente.digitado;
    if (vigente.bruto > 0 && this.lineaGuiadaPorBruto(d)) {
      d.Price = netoDesdeBruto(vigente.bruto, this.tasaTotalLinea(d), this.priceDec);
    }
  }

  VatSum() {
    var sumDetalleImpuesto = 0;
    var impuesto = this.TaxRate;
    // reset split sums
    this.primaryTaxSum = 0;
    this.extraIvaSum = 0;
    const isCLP = this.data.Currency === 'CLP' || !this.data.Currency;
    if (this.data.Detalles && isCLP) {
      // En pesos SAP redondea cada impuesto una vez por documento, sobre la suma de las bases de sus líneas
      const imp = impuestosDocumento(this.data.Detalles.map(element => {
        const { primaryRate, extraIvaRate } = this.tasasLinea(element);
        return { lineTotal: Number(element.LineTotal) || 0, tasaPrimaria: primaryRate, tasaIvaExtra: extraIvaRate };
      }));
      this.primaryTaxSum = imp.primario;
      this.extraIvaSum = imp.ivaExtra;
      this.data.VatSum = imp.total;
    } else if (this.data.Detalles) {
      this.data.Detalles.forEach(element => {

        const { primaryRate, extraIvaRate } = this.tasasLinea(element);

        let primaryForLine = ((Number(element.LineTotal) || 0) * primaryRate) / 100;
        let extraIvaForLine = ((Number(element.LineTotal) || 0) * extraIvaRate) / 100;

        this.primaryTaxSum += primaryForLine;
        this.extraIvaSum += extraIvaForLine;
        
        sumDetalleImpuesto += primaryForLine + extraIvaForLine;
      });

      this.data.VatSum = Math.round((sumDetalleImpuesto + Number.EPSILON) * 100) / 100;

    }
    return this.data.VatSum;
  }

  PrimaryTaxSum() {
    // asegurar recalculo
    this.VatSum();
    const isCLP = this.data.Currency === 'CLP' || !this.data.Currency;
    return isCLP ? Math.round(this.primaryTaxSum) : this.primaryTaxSum;
  }

  ExtraIvaSum() {
    // asegurar recalculo
    this.VatSum();
    const isCLP = this.data.Currency === 'CLP' || !this.data.Currency;
    return isCLP ? Math.round(this.extraIvaSum) : this.extraIvaSum;
  }

  getOSTCRate(code) {
    var impuesto = 0;
    if (this.OSTC) {
      this.OSTC.forEach(element => {
        if (element.Code == code) {
          impuesto = element.Rate;
        }
      });
    }
    return impuesto;
  }

  getImpuestoRate(code) {
    var impuesto = 0;
    if (this.IMPUESTOS) {
      this.IMPUESTOS.forEach(element => {
        if (element.Code == code) {
          impuesto = element.Rate;
        }
      });
    }
    return impuesto;
  }

  /*TotalExpns()
  {
    return this.data.TotalExpns;
  }*/
  DocTotal() {
    const isCLP = this.data.Currency === 'CLP' || !this.data.Currency;
    var rawTotal = ((Number(this.data.GrossProfit) || 0) - (Number(this.data.DiscTotal) || 0)) + (Number(this.data.VatSum) || 0);

    const discCabecera = Number(this.data.DiscPrcnt) || 0;
    if (isCLP && !this.peruApi && discCabecera === 0 && this.data.Detalles && this.data.Detalles.length > 0) {
      const lineas: LineaCuadratura[] = this.data.Detalles.map(d => {
        const tasas = this.tasasLinea(d);
        const vigente = this.brutoVigenteLinea(d);
        return {
          neto: Number(d.Price) || 0,
          cantidad: Number(d.Quantity) || 0,
          descuentoPct: Number(d.Disc) || 0,
          tasaPrimaria: tasas.primaryRate,
          tasaIvaExtra: tasas.extraIvaRate,
          bruto: vigente.bruto,
          guiadaPorBruto: vigente.digitado || this.esBoleta(),
          totalLineaReal: Number(d.LineTotal) || 0
        };
      });
      const cuadratura = cuadrarDocumento(lineas, this.priceDec);
      // El Redondeo oficial de SAP cubre solo lo que se explica por redondeos del desglose de impuestos.
      // Se compara contra los totales en pantalla para no aplicarlo si alguna línea quedó calculada distinto.
      if (cuadratura.aplicaRedondeo && cuadratura.totalCalculado === Math.round(rawTotal)) {
        this.data.Rounding = "Y";
        this.data.RoundDifFC = cuadratura.redondeo;
        this.data.DocTotal = cuadratura.total;
        return this.data.DocTotal;
      }
    }

    this.data.Rounding = "N";
    this.data.RoundDifFC = 0;
    this.data.DocTotal = isCLP ? Math.round(rawTotal) : Math.round((rawTotal + Number.EPSILON) * 100) / 100;
    return this.data.DocTotal;
  }

  // Tras crear una factura o boleta en CLP, compara el total que guardó SAP con el mostrado al vendedor.
  // No bloquea la venta: solo avisa, para que una diferencia nunca pase inadvertida.
  private async verificaCuadraturaSAP(docEntry: any, docNum?: any): Promise<void> {
    try {
      const isCLP = this.data.Currency === 'CLP' || !this.data.Currency;
      const entry = Number(docEntry);
      if (String(this.data.ObjType) !== '13' || this.data.Draft || !isCLP || !Number.isInteger(entry) || entry <= 0) {
        return;
      }
      const esperado = Number(this.data.DocTotal) || 0;
      const res: any = await this._api.GetNotFileQuery("SELECT [DocNum], [DocTotal], [DocTotalFC], [CardCode] FROM [OINV] WHERE [DocEntry] = " + entry);
      const fila = res && res.objeto && res.objeto[0];
      // Si quedó como borrador de aprobación no existe en OINV (o el número corresponde a otro documento)
      if (!fila || String(fila.CardCode) !== String(this.data.CardCode)) {
        return;
      }
      // La moneda local de la sociedad es USD: el total en pesos de un documento CLP queda en DocTotalFC
      const enSap = Math.round(Number(fila.DocTotalFC) || Number(fila.DocTotal) || 0);
      if (enSap !== Math.round(esperado)) {
        console.error('[Venta] Descuadre Intranet vs SAP', { DocEntry: entry, DocNum: fila.DocNum, intranet: esperado, sap: enSap, priceDec: this.priceDec });
        await Swal.fire({
          icon: 'warning',
          title: 'Total distinto en SAP',
          html: `El documento <b>#${fila.DocNum || docNum || entry}</b> se creó, pero SAP registró <b>$${enSap.toLocaleString('es-CL')}</b> y la Intranet mostraba <b>$${Math.round(esperado).toLocaleString('es-CL')}</b>.<br><br>Por favor informa este número de documento a soporte.`
        });
      }
    } catch (e) {
      console.warn('[Venta] No se pudo verificar la cuadratura contra SAP:', e);
    }
  }

  async generarDocumento() {
    this.GrossProfit();
    this.DiscTotal();
    this.VatSum();
    this.DocTotal();

    if (this.ObjType == 23 || this.ObjType == 17) {

        Swal.fire({
          title: 'Espere por favor!',
          html: 'Se está procesando el documento',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading()
          },
        });

        let noborrar = []

    

        
        this.data.UserFields = noborrar;

        if (this.data.Comments) {
          if (!this.data.Comments.includes(this.usuario.NOMBRE)) {
            this.data.Comments = this.usuario.NOMBRE + "\r\n" + this.data.Comments;
          }
        }
        else {
          this.data.Comments = this.usuario.NOMBRE + "\r\n";
        }

        var datos: any;
        var aprobacion: any = await this._apiIndesad.EnviaDocumentoAprobacion(this.data);
        var solicitud: SolicitarAprobacion = aprobacion.resultado;

        

        if (aprobacion.resultado.length > 0) {

          aprobacion.resultado.forEach(element => {

            element.MENSAJE = "";
          });

          this.data.Detalles.forEach(element => {
            if (element.ManBtchNum == "N") {
              element.ManBtchNum = false;
            }
            else
            {
              element.ManBtchNum = true
            }

            if (element.ManSerNum == "N") {
              element.ManSerNum = false;
            }
            else
            {
              element.ManSerNum = true
            }
          });

          var preliminar: DOCUMENTO_MARKETING_PRELIMINAL = {
            APROBACION: aprobacion.resultado,
            ObjType: this.ObjType,
            Documento: this.data,
            usuario: this.usuario,
            APROBADO: false,
          }

          Swal.close();
          // Se solicita aprobación para el documento de nota de venta
          
          // if (this.data.DocEntry > 0) {
          //   var res = await this.SolicitarAprobacion(preliminar);
          // }

          var res = await this.SolicitarAprobacion(preliminar);

          return;
        } else {
          //Swal.fire("Mensaje", "Creacion de documentos deshabilitada", "error");
          //return;
          
          var INTRANET_CREADOR_ENCONTRADO = false;

  

          

    

    
          var U_IND_COMENTARIO_INTERNO_ENCONTRADO = false;

          await this.data.UserFields.forEach(element => {
            if (element.Field == "U_IND_COMENTARIO_INTERNO") {
              U_IND_COMENTARIO_INTERNO_ENCONTRADO = true;
              if (!element.Value) {
                element.Value = this.usuario.NOMBRE;
              }
            }
          });

          if (!U_IND_COMENTARIO_INTERNO_ENCONTRADO) {
            this.data.UserFields.push(
              {
                "Field": "U_IND_COMENTARIO_INTERNO",
                "FieldType": "String",
                "Value": this.usuario.NOMBRE,
              }
            )
          }
          
          this.data.Detalles.forEach(element => {
            element.Currency = this.data.Currency;
          });

          this.data.CntctPrsn = null;
          
          
          
          datos = await this._apiSap.GeneraDocumentoMarketing(this.data);
          
          if (datos.estado) {
            //this.creaActualiza = "Actualizar";
            //this.data = datos.resultado;
            //Swal.fire("Mensaje", datos.mensaje, "success");
            

            
            if (this.documentoOportunidad) {
              
              this.documentoOportunidad.OPR1[this.documentoOportunidad.OPR1.length - 1].DocId = datos.resultado.DocEntry;
              this.documentoOportunidad.DocEntry = datos.resultado.DocEntry;
              this.documentoOportunidad.OPR1[this.documentoOportunidad.OPR1.length - 1].MaxSumLoc = datos.resultado.GrossProfit;
              
              let res:any = await this._apiSap.creaActualizaOportunidad(this.documentoOportunidad);
              
            }

            Swal.fire({
              title: datos.mensaje,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
              icon: "success"
            }).then(async (result) => {

              if (result.isConfirmed) {
                // Si se creó FAC/BOL (ObjType==13) y hay intención de pago, generar pago ahora
                try {
                  if (String(this.data.ObjType) === '13' && this.pagoIntent) {
                    const refDocEntry = datos?.resultado?.DocEntry || datos?.DocEntry || this.data.DocEntry;
                    const payload = {
                      CardCode: this.data.CardCode || '',
                      Fecha: new Date().toISOString(),
                      Comments: 'Pago realizado desde venta',
                      DocEntryReference: refDocEntry,
                      ObjTypeReference: String(this.data.ObjType),
                      CommentsReference: '',
                      cheque: (this.pagoIntent.cheque && this.pagoIntent.cheque.length) ? this.pagoIntent.cheque : null,
                      transferenciaBancaria: this.pagoIntent.transferenciaBancaria || null,
                      tarjetaCredito: (this.pagoIntent.tarjetaCredito && this.pagoIntent.tarjetaCredito.length) ? this.pagoIntent.tarjetaCredito : null,
                      efectivo: this.pagoIntent.efectivo || null,
                    } as any;
                    const resPago: any = await this._ventaService.creaPagoRecibido(payload);
                    if (resPago?.estado) {
                      localStorage.removeItem('TBK_COBRO_PENDIENTE_RECUPERO');
                      this.cobroRescate = null;
                      this.pagoIntent = null; // limpiar
                    } else {
                      console.warn('[Venta] Error al registrar Pago Recibido en SAP:', resPago);
                      const voucher = this.pagoIntent?.tarjetaCredito?.[0]?.voucherNumebr || '';
                      await Swal.fire({
                        icon: 'warning',
                        title: 'Documento creado, pero pago pendiente en SAP',
                        html: `El documento <b>#${datos?.resultado?.DocNum || refDocEntry}</b> se creó exitosamente en SAP, pero el registro contable del pago reportó una observación:<br><br><i>"${resPago?.mensaje || 'Error al procesar pago en SAP'}"</i><br><br><b>El dinero ya fue cobrado al cliente${voucher ? ' (Voucher #' + voucher + ')' : ''}</b>.<br>Puedes asentar el pago en el módulo de <b>Seguimiento</b> utilizando este voucher sin volver a cobrar.`
                      });
                      localStorage.removeItem('TBK_COBRO_PENDIENTE_RECUPERO');
                      this.cobroRescate = null;
                      this.pagoIntent = null;
                    }
                  } else {
                    localStorage.removeItem('TBK_COBRO_PENDIENTE_RECUPERO');
                    this.cobroRescate = null;
                  }
                } catch(e: any) {
                  console.error('[Venta] Excepción al registrar Pago Recibido:', e);
                  localStorage.removeItem('TBK_COBRO_PENDIENTE_RECUPERO');
                  this.cobroRescate = null;
                  this.pagoIntent = null;
                }
              //if (false) {

                if (this.ObjType == "23")
                {
                  this.router.navigate(['/Seguimiento/COT']);
                }
                else if(this.ObjType == "17")
                {
                  this.router.navigate(['/Seguimiento/NV']);
                }
                else if(this.ObjType == "13")
                {
                  this.router.navigate(['/Seguimiento/FAC']);
                }
                else if(this.ObjType == "22")
                {
                  this.router.navigate(['/Seguimiento/COMPRA']);
                }

              }
            })

          }
          else {
            const voucher = this.pagoIntent?.tarjetaCredito?.[0]?.voucherNumebr || '';
            const monto = this.pagoIntent?.tarjetaCredito?.[0]?.ammountDue || 0;
            if (voucher && monto > 0) {
              Swal.fire({
                icon: 'error',
                title: 'No se pudo crear el documento en SAP',
                html: `SAP reportó el siguiente error:<br><br><i>"${datos.mensaje}"</i><br><br><div class="alert alert-warning text-start small"><b>⚠️ IMPORTANTE:</b> El cobro con tarjeta por <b>$${Number(monto).toLocaleString('es-CL')}</b> (Voucher <b>#${voucher}</b>) ya fue aprobado en el POS.<br><br><b>NO vuelvas a cobrar al cliente</b>. Corrige el dato observado en pantalla y presiona Crear nuevamente.</div>`
              });
            } else {
              Swal.fire("Mensaje", datos.mensaje, "error");
            }
          }
        }





    }

    else

    {
      Swal.fire({
        title: 'Espere por favor!',
        html: 'Se está procesando el documento',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading()
        },
      });


      let noborrar = []

      if (!environment.RUTA_API.includes("peru")) {

        this.data.UserFields.forEach(element => {
          if (element.Field == "U_IND_COMENTARIO_FACTURA" || element.Field == "U_IND_COMENTARIO_PEDIDO" || element.Field == "U_IND_ESTADO_WMS") {
            noborrar.push(element)
          }
        });

      }

      this.data.UserFields = noborrar;

      // Añade comentarios al documento generado en SAP
      if (this.data.Comments) {
        if (!this.data.Comments.includes(this.usuario.NOMBRE)) {
          this.data.Comments = this.usuario.NOMBRE + "\r\n" + this.data.Comments;
        }
      }
      else {
        this.data.Comments = this.usuario.NOMBRE + "\r\n";
      }


      var datos: any;
      var aprobacion: any = await this._apiIndesad.EnviaDocumentoAprobacion(this.data);//VerificarDocumentoAprobación
      var solicitud: SolicitarAprobacion = aprobacion.resultado;


      if (aprobacion.resultado.length > 0) {

        aprobacion.resultado.forEach(element => {

          element.MENSAJE = "";
        });

        var preliminar: DOCUMENTO_MARKETING_PRELIMINAL = {
          APROBACION: aprobacion.resultado,
          ObjType: this.ObjType,
          Documento: this.data,
          usuario: this.usuario,
          APROBADO: false,
        }


        Swal.close();
        // Se solicita aprobación para el documento de nota de venta
        
        // if (this.data.DocEntry > 0) {
        //   var res = await this.SolicitarAprobacion(preliminar);
        // }
        var res = await this.SolicitarAprobacion(preliminar);


        return;
      } else {
        //Swal.fire("Mensaje", "Creacion de documentos deshabilitada", "error");
        //return;
        if (this.data.DocEntry) {
          this.data.ID_USUARIO_MODIFICACION = localStorage.getItem("ID_LOGUEADO")
        }
        else
        {
          this.data.ID_USUARIO = localStorage.getItem("ID_LOGUEADO");
        }

        //actualiza currency detalle
        this.data.Detalles.forEach(element => {
          element.Currency = this.data.Currency
        });

        
        datos = await this._apiSap.GeneraDocumentoMarketing(this.data);

        if (datos.estado) {
          //this.creaActualiza = "Actualizar";
          //this.data = datos.resultado;
          //Swal.fire("Mensaje", datos.mensaje, "success");
          await this.verificaCuadraturaSAP(datos?.resultado?.DocEntry || datos?.DocEntry, datos?.resultado?.DocNum);
          Swal.fire({
            title: datos.mensaje,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: 'Ok',
            icon: "success"
          }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              // Pago post-creación para FAC/BOL si quedó intención guardada
              try {
                if (String(this.data.ObjType) === '13' && this.pagoIntent) {
                  const refDocEntry = datos?.resultado?.DocEntry || datos?.DocEntry || this.data.DocEntry;
                  const payload = {
                    CardCode: this.data.CardCode || '',
                    Fecha: new Date().toISOString(),
                    Comments: 'Pago realizado desde venta',
                    DocEntryReference: refDocEntry,
                    ObjTypeReference: String(this.data.ObjType),
                    CommentsReference: '',
                    cheque: (this.pagoIntent.cheque && this.pagoIntent.cheque.length) ? this.pagoIntent.cheque : null,
                    transferenciaBancaria: this.pagoIntent.transferenciaBancaria || null,
                    tarjetaCredito: (this.pagoIntent.tarjetaCredito && this.pagoIntent.tarjetaCredito.length) ? this.pagoIntent.tarjetaCredito : null,
                    efectivo: this.pagoIntent.efectivo || null,
                  } as any;
                  const resPago: any = await this._ventaService.creaPagoRecibido(payload);
                  if (resPago?.estado) {
                    localStorage.removeItem('TBK_COBRO_PENDIENTE_RECUPERO');
                    this.cobroRescate = null;
                    this.pagoIntent = null;
                  } else {
                    console.warn('[Venta] Error al registrar Pago Recibido en SAP:', resPago);
                    const voucher = this.pagoIntent?.tarjetaCredito?.[0]?.voucherNumebr || '';
                    await Swal.fire({
                      icon: 'warning',
                      title: 'Documento creado, pero pago pendiente en SAP',
                      html: `El documento <b>#${datos?.resultado?.DocNum || refDocEntry}</b> se creó exitosamente en SAP, pero el registro contable del pago reportó una observación:<br><br><i>"${resPago?.mensaje || 'Error al procesar pago en SAP'}"</i><br><br><b>El dinero ya fue cobrado al cliente${voucher ? ' (Voucher #' + voucher + ')' : ''}</b>.<br>Puedes asentar el pago en el módulo de <b>Seguimiento</b> utilizando este voucher sin volver a cobrar.`
                    });
                    localStorage.removeItem('TBK_COBRO_PENDIENTE_RECUPERO');
                    this.cobroRescate = null;
                    this.pagoIntent = null;
                  }
                } else {
                  localStorage.removeItem('TBK_COBRO_PENDIENTE_RECUPERO');
                  this.cobroRescate = null;
                }
              } catch(e: any) {
                console.error('[Venta] Excepción al registrar Pago Recibido:', e);
                localStorage.removeItem('TBK_COBRO_PENDIENTE_RECUPERO');
                this.cobroRescate = null;
                this.pagoIntent = null;
              }
              // Soft reset: reutiliza datos de referencia ya cargados (OCRD, OWHS, OSLP, etc.)
              await this.softReset();
            }
          })

        }
        else {
          const voucher = this.pagoIntent?.tarjetaCredito?.[0]?.voucherNumebr || '';
          const monto = this.pagoIntent?.tarjetaCredito?.[0]?.ammountDue || 0;
          if (voucher && monto > 0) {
            Swal.fire({
              icon: 'error',
              title: 'No se pudo crear el documento en SAP',
              html: `SAP reportó el siguiente error:<br><br><i>"${datos.mensaje}"</i><br><br><div class="alert alert-warning text-start small"><b>⚠️ IMPORTANTE:</b> El cobro con tarjeta por <b>$${Number(monto).toLocaleString('es-CL')}</b> (Voucher <b>#${voucher}</b>) ya fue aprobado en el POS.<br><br><b>NO vuelvas a cobrar al cliente</b>. Corrige el dato observado en pantalla y presiona Crear nuevamente.</div>`
            });
          } else {
            Swal.fire("Mensaje", datos.mensaje, "error");
          }
        }
      }
    }

  }

  async getUsuarios()
  {
    let data:any;
    var res:any = await this._api.getAllLogin();
    if(res.estado)
    {
      data = [...res.objeto];
      
    }
    return data

  }


  nombreCampo(field: String) {
    var descripcion: string = "";
    var objType = this.data.ObjType;
    // if (objType == '540000006') {
    //   objType = '22';
    // }
    if (this.objetoSAP) {
      var filtro = this.objetoSAP.filter(a => a.ObjType == objType);
      var filtro2 = filtro[0].Fields.filter(a => a.Field == field);

      descripcion = filtro2[0].Description;
    }
    /*
    if (objType == "23" || objType == "17") {
      if (field == "CardCode") {
        descripcion = "Cliente";
      }
      else if (field == "ShipToDef") {
        descripcion = "Dirección de despacho";
      }
      else if (field == "BillToDef") {
        descripcion = "Dirección de factura";
      }
      else if (field == "GroupNum") {
        descripcion = "Condición de pago";
      }
      else if (field == "TrnspCode") {
        descripcion = "Forma de envio";
      }
      else if (field == "DocDueDate") {
        descripcion = "Fecha Estimada Entrega";
      }
      else if (field == "SlpCode") {
        descripcion = "Ejecutivo comercial";
      }
      else if (field == "DocumentDetails") {
        descripcion = "Detalle de venta";
      }
    }
    else if (objType == "540000006" || objType == "22") { //compras
      if (field == "CardCode") {
        descripcion = "Proveedor";
      }
      else if (field == "ShipToDef") {
        descripcion = "Dirección de recepción";
      }
      else if (field == "BillToDef") {
        descripcion = "Dirección de factura";
      }
      else if (field == "GroupNum") {
        descripcion = "Condición de pago";
      }
      else if (field == "TrnspCode") {
        descripcion = "Forma de recepción";
      }
      else if (field == "DocDueDate") {
        descripcion = "Fecha Estimada Recepción";
      }
      else if (field == "SlpCode") {
        descripcion = "Ejecutivo de compras";
      }
      else if (field == "DocumentDetails") {
        descripcion = "Detalle de compra";
      }
    }*/


    return descripcion;
  }


  EsCotizacion() {

    if (environment.RUTA_API.includes("peru")) {

    }else{
    // if(this.usuario.RUT=="10788816-0" || this.usuario.RUT=="16608417-2"){
      if (this.usuario.ADMIN || (this.ObjType != "23" && this.ObjType != "17")) {
        return false;
      } else {
        return true;
      }

      return true;
      if (this.ObjType == "23") {
        return true;
      } else {
        return false;
      }

    }





  }

  CargarUsuario() {

  }
  UploadFiles() {


  }
  async SolicitarAprobacion(respuesta) {

    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "lg",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG
    };
    const modalRef = this.modalService.open(ModeloAprobacionCRMComponent, ngbModalOptions);
    modalRef.componentInstance.obj = respuesta;
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.result.then((datos) => {
      
      if (datos) {
        if (datos.estado) {
          //this.creaActualiza = "Actualizar";
          //this.data = datos.resultado;
          //Swal.fire("Mensaje", datos.mensaje, "success");
          Swal.fire({
            title: datos.mensaje,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: 'Ok',
            icon: "success"
          }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              await this.softReset();
            }
          })

        }
        else {
          Swal.fire("Mensaje", datos.mensaje, "error");
        }
      }


    }, (reason) => {
      //this.editar(item);
    });

  }

  liquidacion(item:any){
    Swal.fire({
      icon: 'warning',
      title: 'Producto en Liquidación',
      text: 'Este producto está en liquidación.', 
      timer: 3000, 
      timerProgressBar: true,
      showConfirmButton: false 
    });

    
    
    
    
    
    

    if (item.Disc > item.DiscOriginal || item.Price < item.PriceOriginal || item.PriceAfeterDisc > item.PriceAfeterDiscOriginal) {
      item.Price = Number(item.PriceOriginal);
      item.Disc = Number(item.DiscOriginal);
      item.PriceAfeterDisc = Number(item.PriceAfeterDiscOriginal);
    }


  }



  async cargaUNDTIPO(){


    Swal.fire({
      title: 'Espere por favor!',
      html: 'Se están cargando los precios',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading()
      },
    });


    let condicionListaMateriales = "ListaMateriales";
    var data:any = await this._api.getQueryAll();
    var query:string = "";
    
    await data.objeto.forEach(element => {
      if (element.NOMBRE == condicionListaMateriales) {
        query = element.CONSULTA;
      }
    });
    

    query = query.replace("REEMPLAZA", "2");
    data = await this._api.GetNotFileQuery(query);
    

    let materiales = data.objeto;

    this.data.Detalles.forEach(element => {
      materiales.forEach(mat => {
        if (element.ItemCode == mat.ItemCode) {
          let userField = {
            Field:"U_IND_TIPO",
            FieldType: "String",
            Value:mat.U_IND_TIPO
          }
          element.UserFields.push(userField);
        }
      });
    });

    Swal.close();


  }

  documentoOportunidad:any = null;

  async agregarOportunidad(){

    

    if (this.data.DocTotal) {

      try {
        const configRes: any = await this._apiMongo.getConfiguracionGeneral('opciones_intranet');
        if (configRes.estado && configRes.resultado && configRes.resultado.valor && configRes.resultado.valor.exigir_oportunidad === false) {
             this.generarDocumento();
             return;
        }
      } catch (e) {
        
      }

      let ngbModalOptions: NgbModalOptions = {
        backdrop: 'static',
        keyboard: false,
        size: "xl",
        scrollable: true
      };


      const modalRef = this.modalService.open(SeguimientoOportunidadComponent, ngbModalOptions);
      modalRef.componentInstance.documento = this.data;
      modalRef.componentInstance.desdeVenta = true;
      modalRef.componentInstance.modalReference = modalRef;

      modalRef.result.then((data) => {

      if (data) {
        this.documentoOportunidad = data;
        
        this.generarDocumento()
      }
      else
      {
        Swal.fire("Mensaje", "El documento debe tener una oportunidad enlazada para ser creado", "error");
      }

      });

    }
    else
    {
      Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      }).fire({
        icon: 'error',
        title: "El documento no puede tener un Monto Total de $0"
      });
    }



  }

  async verAdjunto(item:any){
    let res:any = await this._apiSap.verAdjunto(item);
    if (res.estado) {
      window.open(environment.RUTA_API + res.resultado.rutaServerFile, '_blank');
    }
  }

  async eliminaAdjunto(adjunto:any){
    
    let elimina:any = await this._api.GetNotFileQuery('DELETE FROM ATC1 WHERE [AbsEntry] = '+adjunto.AbsEntry+' AND [Line] = '+adjunto.Line+'');
    
    if (elimina.estado) {
      Swal.fire('success',"archivo eliminado");
      await this.traeArchivos();
    }
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];

    if (file) {
      this.readFile(file);
    }
  }

  readFile(file: File): void {
    const reader = new FileReader();

    reader.onloadend = async () => {
      const base64Data = reader.result as string;
      const fileName = file.name;
      const fileExt = this.getFileExtension(fileName);

      const fileInfo = {
        AbsEntry: -1,
        srcPath: base64Data,
        FileName: fileName,
        FileExt: fileExt
      };

      await this.creaArchivo(fileInfo);


      



    };

    reader.readAsDataURL(file);
  }

  getFileExtension(fileName: string): string {
    return fileName.slice((fileName.lastIndexOf('.') - 1 >>> 0) + 2);
  }

  async creaArchivo(file){
    this.cargando = true;

    if (this.data.AtcEntry) {
      file.AbsEntry = this.data.AtcEntry;
    }
    else
    {
      file.AbsEntry = -1;
    }

    let res:any = await this._apiSap.creaActualizaAdjunto(file.AbsEntry,file.srcPath,file.FileName,file.FileExt);
    
    if (res.estado) {
      if (!this.data.AtcEntry || this.data.AtcEntry == -1) {
        this.data.AtcEntry = res.resultado.AbsEntry;
      }
      await this.traeArchivos();
      Swal.fire({
        icon: 'success',
        title: 'Éxito',
        text: res.mensaje,
      });
    }
    else
    {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: res.mensaje,
      });
    }

    this.cargando = false;

  }

  listaCodigoTransworld:any;
  async obtieneCodTransworld(){
    var query = "SELECT [U_IND_SWW],[ItemCode] FROM OITM";
    let res:any = await this._api.GetNotFileQuery(query);
    if (res.estado) {
      this.listaCodigoTransworld = res.objeto;
    }
  }

}

//http://localhost:4200/Venta/17/9665
